webpackJsonp([129],{

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(132)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  "data-v-340caa1c",
  /* cssModules */
  null
)
Component.options.__file = "/var/lib/jenkins/workspace/前端/private-build-new-gc-vue/new_GC_master/src/core/components/empty.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] empty.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-340caa1c", Component.options)
  } else {
    hotAPI.reload("data-v-340caa1c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  fieldStatus: {
    true: "显示",
    false: "隐藏"
  },
  recommendStatus: {
    true: "取消推荐",
    false: "推荐"
  },
  hotStatus: {
    true: "取消热点",
    false: "热点"
  },
  newestStatus: {
    true: "取消最新",
    false: "最新"
  },
  topStatus: {
    true: "取消置顶",
    false: "置顶"
  },
  //搜索引擎收录状态
  inclusionSate: {
    true: "已收录",
    false: "未收录"
  },
  dragType: {
    before: "above",
    after: "below",
    inner: "bottom_asc"
  },
  contentApi: {
    top: {
      url: 'top',
      true: '置顶'
    },
    hot: {
      url: 'hot',
      true: '热点'
    },
    newest: {
      url: 'newest',
      true: '最新'
    },
    pcShow: {
      url: 'updateShow',
      false: '隐藏',
      true: '显示'
    },
    recommend: {
      url: 'recommend',
      true: '推荐'
    }
  },
  attribute: {
    false: '取消',
    true: ''
  },
  viewType: 1,
  menuType: {
    'column': 223,
    'content': 224
  },
  pageType: {
    1: '综合',
    2: '列表',
    3: '详情'
  },
  imageWater: {
    1: '取消',
    0: '添加'
  },
  isOpenReview: {
    true: '是',
    false: '否'
  },
  reviewLevel: [{
    id: 1,
    name: '一级审核'
  }, {
    id: 2,
    name: '二级审核'
  }, {
    id: 3,
    name: '三级审核'
  }, {
    id: 4,
    name: '四级审核'
  }, {
    id: 5,
    name: '五级审核'
  }],
  businessReminding: {
    0: "个人",
    1: "企业"
  },
  emailState: {
    true: "启用",
    false: "停用"
  },
  contentReviewState: { //用于审核任务列表中
    0: '终审驳回',
    1: '待审核',
    99999: '审核通过'
  },
  contentAuditState: { //用于内容列表中
    0: '草稿',
    2: '终审驳回',
    1: '待审核',
    99999: '审核通过'
  },
  checkState: {
    0: '终审驳回',
    1: '审核通过',
    2: '审核不通过',
    3: '审核驳回',
    4: '待审核',
    99999: '终审通过'
  },
  formStatus: { //万能表单中的表单状态
    0: '全部',
    1: '待审核',
    2: '有效',
    3: '无效'
  },
  useState: {
    0: '停用',
    1: '开启'
  },
  equipment: {
    1: '电脑',
    2: '手机'
  }
});

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'COLUMN': 0, //栏目id
  'CONTENT': 1, //内容id
  'IMAGE': 2, //图片id
  'FILE': 3, //文件id
  'VIDEO': 4, //视频库id
  'BANNER': 5, //广告位id
  'INFORMAN': 6, //信息管理id
  'REVIEW': 7, //审批管理
  'APP': 8, // 应用中心
  'SUPERADMIN': '0'
});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return errorCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return errorCodeByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return constans; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(86);



var processEnv = __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"});
var permissionInfo = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo;

var config = {
  originalForward: {
    url: "/originalForward.do"
  },
  gwforward: {
    url: "/gwforward"
  },
  findMemu: {
    //获取菜单
    url: "/findMemu",
    method: "GET",
    baseUrl: processEnv.ISPRIVATE ? processEnv.ORIGINAL_ROOT + processEnv.MENU_URL : processEnv.MENU_URL
  },

  getTenantInfoByTenantId: {
    // 获取租户信息
    url: processEnv.GATEWAY ? "/local/getTenantById" : "/getTenantById",
    method: "GET",
    baseUrl: processEnv.ISPRIVATE ? processEnv.ORIGINAL_ROOT + "/tenant" : ""
  },

  saveColumn: {
    //添加栏目
    url: "/cmscolumn/appcolumn/saveColumn",
    method: "POSTJSON"
    //authPermission: 'column_add'
  },
  updateColumn: {
    //修改栏目
    url: "/cmscolumn/appcolumn/updateColumn",
    method: "POSTJSON"
    //authPermission: 2
  },
  batchUpdateDisplay: {
    //
    url: "/cmscolumn/column/batchUpdateDisplay",
    method: "POSTJSON"
    //authPermission: "2"
  },
  copyColumn: {
    url: "/cmscolumn/appcolumn/copyColumn",
    method: "POSTJSON"
    //authPermission: "1"
  },
  validColumnByColumnIds: {
    //验证栏目是否还有内容
    url: "/cmscolumn/appcolumn/validateIdDel",
    method: "GET"
  },
  deleteColumnByColumnIds: {
    //根据批量栏目ID删除栏目
    url: "/cmscolumn/appcolumn/deleteColumnByColumnIds",
    method: "POSTJSON"
  },
  dragAndDropSort: {
    //拖拽转移/排序
    url: "/cmscolumn/column/dragAndDropSort",
    method: "GET"
    //authPermission: "25"
  },
  batchMoveColumn: {
    //批量转移栏目到目标栏目最底部
    url: "/cmscolumn/column/batchMoveColumn",
    method: "POSTJSON"
    //authPermission: "21"
  },
  getColumnTree: {
    //获取栏目tree
    url: "/cmscolumn/appcolumn/getColumnTree",
    method: "GET"
  },
  getSiteColumnTree: {
    //获取种子站栏目tree
    url: "/cmscolumn/appcolumn/getSiteColumnTree",
    method: "GET"
  },
  getColumnById: {
    //根据栏目ID获取栏目
    url: "/cmscolumn/appcolumn/getColumnById",
    method: "GET"
  },
  findColumnByConditionWithPage: {
    //根据条件分页获取栏目
    url: "/cmscolumn/column/findColumnByConditionWithPage",
    method: "POSTJSON"
  },
  findColumnByCondition: {
    url: "/cmscolumn/column/findColumnByCondition",
    method: "POSTJSON"
  },
  getCountries: {
    url: '/region/countryService/getCountries',
    method: 'GET'
  },
  getRegionsTree: {
    url: '/region/regionService/getRegionsTree',
    method: 'GET'
  },
  saveGroup: {
    //添加栏目组
    url: "/cmscolumn/column/saveGroup",
    method: "POSTJSON"
    //authPermission: "9"
  },
  updateGroup: {
    //修改栏目组
    url: "/cmscolumn/column/updateGroup",
    method: "POSTJSON"
    //authPermission: "10"
  },
  deleteGroup: {
    //删除栏目组
    url: "/cmscolumn/column/deleteGroup",
    method: "POSTJSON"
    //authPermission: "11"
  },
  getGroupById: {
    //根据栏目组ID获取栏目组
    url: "/cmscolumn/column/getGroupById",
    method: "GET"
  },
  findColumnByGroupId: {
    url: "/cmscolumn/column/findColumnByGroupId",
    method: "GET"
  },
  getColumnGroup: {
    //获取栏目组列表
    url: "/cmscolumn/column/findAllGroup",
    method: "GET"
  },
  ResetColumnGroupPK: {
    url: "/cmscolumn/column/ResetColumnGroupPK",
    method: "POSTJSON"
    //authPermission: "2"
  },
  saveColumnGroupPK: {
    //批量保存栏目与栏目组关系
    url: "/cmscolumn/column/saveColumnGroupPK",
    method: "POSTJSON"
    //authPermission: "10"
  },
  deletePKByColumnIdOrGroupId: {
    //根据批量栏目ID或批量栏目组Id删除关系
    url: "/cmscolumn/column/deletePKByColumnIdOrGroupId",
    method: "POSTJSON"
    //authPermission: "10"
  },

  // 获取字段类型
  getFiledType: {
    url: "/cmscolumn/field/getFieldType",
    method: "GET"
  },

  saveField: {
    //添加栏目内容字段
    url: "/cmscolumn/field/saveField",
    method: "POSTJSON"
    //authPermission: "15"
  },
  saveFieldByTempId: {
    //根据字段模板Id添加栏目内容字段
    url: "/cmscolumn/field/saveFieldByTempId",
    method: "POSTJSONGET"
    //authPermission: "15"
  },
  updateField: {
    //根据字段模板Id添加栏目内容字段
    url: "/cmscolumn/field/updateField",
    method: "POSTJSON"
    //authPermission: "16"
  },
  batchUpdateField: {
    //根据字段模板Id添加栏目内容字段批量修改
    url: "/cmscolumn/field/batchUpdateField",
    method: "POSTJSON"
  },
  updateFieldBase: {
    //根据字段模板Id添加栏目内容字段
    url: "/cmscolumn/field/updateFieldBase",
    method: "POSTJSON"
    // authPermission: "16"
  },
  batchUpdateFieldDisplay: {
    //根据字段模板Id批量显示隐藏d
    url: "/cmscolumn/field/batchUpdateDisplay",
    method: "POSTJSON"
  },
  deleteField: {
    //根据批量栏目内容字段ID删除字段
    url: "/cmscolumn/field/deleteField",
    method: "POSTJSON"
    //authPermission: "17"
  },
  getFieldById: {
    //根据栏目内容字段ID获取栏目内容字段对象
    url: "/cmscolumn/field/getFieldById",
    method: "GET"
  },
  findFieldByConditionWithPage: {
    //根据条件分页查询栏目内容字段
    url: "/cmscolumn/field/findFieldByConditionWithPage",
    method: "POSTJSON"
  },
  validateFieldName: {
    //校验字段名
    url: "/cmscolumn/field/validateFieldName",
    method: "GET"
  },

  //根据类型校验字段名
  validateFieldNameByType: {
    url: "/cmscolumn/field/validateFieldNameWithType",
    method: "GET"
  },

  findFieldsByColumnIds: {
    url: "/cmscolumn/field/findFieldsByColumnIds",
    method: "GET"
  },
  findFieldByCondition: {
    //根据条件查询栏目内容字段
    url: "/cmscolumn/field/findFieldByCondition",
    method: "POSTJSON"
  },
  findFieldsByColumnIdOrTempId: {
    //根据种子站栏目ID获取字段组
    url: "/cmscolumn/field/findFieldsByColumnIdOrTempId",
    method: "GET"
  },
  findFieldWithRangeByCondition: {
    //根据条件查询栏目内容字段包含区间字段
    url: "/cmscolumn/field/findFieldWithRangeByCondition",
    method: "POSTJSON"
  },
  dragAndDropSortField: {
    url: "/cmscolumn/field/dragAndDropSort",
    method: "GET"
    //authPermission: "16"
  },

  // saveItems: {//批量添加栏目内容选项型字段条目
  //   url: '/cmscolumn/field/saveItems',
  //   method: 'POSTJSON'
  // },
  // updateItem: {//修改字段ID删除条目
  //   url: '/cmscolumn/field/updateItem',
  //   method: 'POSTJSON'
  // },
  // deleteByFieldIds: {//根据批量字段ID删除条目
  //   url: '/cmscolumn/field/deleteByFieldIds',
  //   method: 'POSTJSON'
  // },
  // findItemsByFieldId: {//根据字段ID获取条目
  //   url: '/cmscolumn/field/findItemsByFieldId',
  //   method: 'GET'
  // },
  // saveValidate: {//保存栏目内容字段校验对象
  //   url: '/cmscolumn/field/saveValidate',
  //   method: 'POSTJSON'
  // },
  // updateValidate: {//修改栏目内容字段校验对象
  //   url: '/cmscolumn/field/updateValidate',
  //   method: 'POSTJSON'
  // },
  saveOrUpdateValidate: {
    //保存或更新字段的表单验证
    url: "/cmscolumn/field/saveOrUpdateValidate",
    method: "POSTJSON"
    //authPermission: "16"
  },
  // deleteValidateByFieldIds: {//根据批量字段ID删除栏目内容字段校验对象
  //   url: '/cmscolumn/field/deleteValidateByFieldIds',
  //   method: 'POSTJSON'
  // },
  getValidateByFieldId: {
    //根据字段ID获取栏目内容字段校验对象
    url: "/cmscolumn/field/getValidateByFieldId",
    method: "GET"
  },
  findGroupByColumnId: {
    //根据栏目ID获取字段组
    url: "/cmscolumn/field/findGroupByColumnId",
    method: "GET"
  },
  getFieldGroupById: {
    //根据ID获取字段组
    url: "/cmscolumn/field/getGroupById",
    method: "GET"
  },
  saveFieldGroup: {
    //保存字段组
    url: "/cmscolumn/field/saveGroup",
    method: "POSTJSON"
    //authPermission: "18"
  },
  updateFieldGroup: {
    //更新字段组
    url: "/cmscolumn/field/updateGroup",
    method: "POSTJSON"
    //authPermission: "19"
  },
  deleteFieldGroup: {
    //删除字段组
    url: "/cmscolumn/field/deleteGroup",
    method: "POSTJSON"
    //authPermission: "20"
  },

  /*-------------------------------------------- 内容 ----------------------------------------------------*/

  insertContent: {
    //添加内容
    url: "/cmscontent/appContentService/insert",
    method: "POSTJSON"
    //authPermission: "columnId:27"
  },
  updateContent: {
    // 更新内容
    url: "/cmscontent/appContentService/update",
    method: "POSTJSON"
    //authPermission: "columnId:28"
  },
  copyInsert: {
    //复制
    url: "/cmscontent/contentManualService/copyInsert",
    method: "GET"
    //authPermission: "columnId:27"
  },
  selectContent: {
    // 查询单条 内容对象
    url: "/cmscontent/appContentService/select",
    method: "GET"
  },
  findByPagination: {
    // 分页查询  (内容列表)
    url: "/cmscontent/appContentService/findByPagination",
    method: "POSTJSON"
  },
  findContentByPagination: {
    // 分页查询  (内容列表新)
    url: "/cmscontent/appContentService/findContentByPagination",
    method: "POSTJSON"
  },
  // 导出内容模板
  exportContentTemplate: {
    url: "/cmscontent/appContentService/getTemplate",
    method: "GET"
  },

  // 导入内容模板
  importContentTemplate: {
    url: "/cmscontent/appContentService/importContent",
    method: "FILESTREAM"
  },

  updateShow: {
    // 更新内容隐藏可见
    url: "/cmscontent/contentManualService/updateShow",
    method: "POSTJSON"
    //authPermission: "columnId:28"
  },
  top: {
    // 置顶
    url: "/cmscontent/contentManualService/top",
    method: "POSTJSON"
    //authPermission: "columnId:28"
  },

  recommend: {
    // 推荐/取消推荐内容
    url: "/cmscontent/contentManualService/recommend",
    method: "POSTJSON"
    //authPermission: "columnId:28"
  },
  ResetContentGroupPK: {
    // 绑定内容内容组关系
    url: "/cmscontent/contentManualService/restContentGroup",
    method: "POSTJSON"
    //authPermission: "columnId:28"
  },

  hot: {
    // 热点/取消热点内容
    url: "/cmscontent/contentManualService/hot",
    method: "POSTJSON"
    //authPermission: "columnId:28"
  },
  newest: {
    // 最新/取消最新内容
    url: "/cmscontent/contentManualService/newest",
    method: "POSTJSON"
  },
  sort: {
    // 排序
    url: "/cmscontent/contentManualService/sort",
    method: "GET"
    //authPermission: "columnId:28"
  },
  findFieldsByColumnId: {
    url: "/cmscolumn/field/findFieldsByColumnId",
    method: "GET"
  },
  updateDel: {
    // 删除
    url: "/cmscontent/contentManualService/updateDel",
    method: "POSTJSON"
    //authPermission: "columnId:29"
  },
  rebackContent: {
    // 还原
    url: "/cmscontent/contentManualService/updateDel",
    method: "POSTJSON"
    //authPermission: "6"
  },
  contentTransfer: {
    //内容转移
    url: "/cmscontent/contentManualService/transfer?",
    method: "POSTJSON"
    //authPermission: "trasColumnId:31"
  },
  getSendState: {
    // 判断栏目有没有手动转发
    url: "/cmscontent/appContentForwardService/getSendState",
    method: "POSTJSON"
  },
  manualForward: {
    // 手动跨站转发
    url: "/cmscontent/appContentForwardService/manualForward",
    method: "POSTJSON"
    //authPermission: "columnId:31"
  },
  hasForward: {
    // 判断内容是否转发过
    url: "/cmscontent/appContentForwardService/hasForward",
    method: "POSTJSON"
  },
  //--------------------------------图片插件-------------------------------------------------
  findByPaginationForImage: {
    //分页查找
    url: "/imageRepository/imageRepositoryService/findByPagination",
    method: "POSTJSON"
  },
  deleteImageInfo: {
    //删除图片
    url: "/imageRepository/imageRepositoryService/deleteImageInfo",
    method: "POSTJSON"
    //authPermission: "46"
  },
  updateImage: {
    //更新单个updateImageInfo
    url: "/imageRepository/imageRepositoryService/updateImage",
    method: "FILE"
    //authPermission: "44"
  },
  updateImageInfo: {
    url: "/imageRepository/imageRepositoryService/updateImageInfo",
    method: "POSTJSON"
    //authPermission: "44"
  },
  uploadImage: {
    //添加图片
    url: "/imageRepository/imageFileUpload",
    method: "UPLOADFILE",
    //authPermission: "43",
    baseUrl: processEnv.DSSRESOURCES,
    isGwforward: true //true走gwforward转发
  },
  getImageInfo: {
    //获取图片getImageInfo
    url: "/imageRepository/imageRepositoryService/getImageInfo",
    method: "GET"
  },
  setWaterMark: {
    //批量添加水印setWaterMark
    url: "/imageRepository/imageRepositoryService/setWaterMark",
    method: "POSTJSON"
    //authPermission: "47"
  },
  cancelWatermark: {
    //批量删除水印cancelWatermark
    url: "/imageRepository/imageRepositoryService/cancelWatermark",
    method: "POSTJSON"
    //authPermission: "47"
  },
  getImageWatermark: {
    //获取水印设置getImageWatermark
    url: "/imageRepository/imageWatermarkService/getImageWatermark",
    method: "GET"
  },
  saveOrUpdateWaterMark: {
    //保存或修改水印saveOrUpdateWaterMark
    url: "/imageRepository/imageWatermarkService/saveOrUpdateWaterMark",
    method: "POSTJSON"
    //authPermission: "47"
  },
  updateAppCode: {
    //转移分类updateAppCode
    url: "/imageRepository/imageRepositoryService/updateAppCode",
    method: "POSTJSON"
    //authPermission: "45"
  },
  findAllClassify: {
    //获取APP_ID下所有分类findAllClassify
    url: "/classify/findAllClassify",
    method: "POSTJSON"
  },
  findAllClassifyByImage: {
    //获取APP_ID下所有分类文件findAllClassify及数量
    url: "/imageRepository/appImageRepositoryService/findAllClassify",
    method: "POSTJSON"
  },
  saveClassify: {
    //保存分类信息 saveClassify
    url: "/classify/saveClassify",
    method: "POSTJSON"
    //authPermission: "86"
  },
  updateClassify: {
    //更新分类信息 updateClassify
    url: "/classify/updateClassify",
    method: "POSTJSON"
    //authPermission: "87"
  },
  deleteClassifyByIds: {
    //删除分类信息 deleteClassifyByIds
    url: "/classify/deleteClassifyByIds",
    method: "POSTJSON"
    //authPermission: "88"
  },
  getClassifyById: {
    //根据id获取分类信息 getClassifyById
    url: "/classify/getClassifyById",
    method: "GET"
  },
  getClassifyByName: {
    //根据name获取分类信息 getClassifyByName
    url: "/classify/getClassifyByName",
    method: "GET"
  },
  preWaterMark: {
    //水印预览
    url: "/imageRepository/imageWatermarkService/preWaterMark",
    method: "POSTJSON"
  },
  getImageUsage: {
    //获取图片资源
    url: "/imageRepository/imageRepositoryService/getImageUsage",
    method: "GET"
  },

  //--------------------------------文件库插件-------------------------------------------------
  uploadFile: {
    //根据条件分页查询文件库信息findByPagination
    url: "/upload/uploadService/uploadFile"
    //authPermission: "48"
  },
  updateFile: {
    //根据条件分页查询文件库信息findByPagination
    url: "/upload/uploadService/updateFile"
    //authPermission: "49"
  },
  findByPaginationForFile: {
    //根据条件分页查询文件库信息findByPagination
    url: "/file/info/findWithPage",
    method: "POSTJSON"
  },
  deleteFileByIds: {
    //根据批量文件库信息id删除未引用文件delete
    url: "/file/appinfo/deleteFileByIds",
    method: "POSTJSON"
    //authPermission: "51"
  },
  saveFile: {
    //保存文件库信息saveFileInfomation
    url: "/file/info/saveFile",
    method: "POSTJSON"
    //authPermission: "48"
  },
  getFileById: {
    //根据文件ID查询文件信息get
    url: "/file/info/getFileById",
    method: "GET"
  },
  modifyFileName: {
    //修改文件名get
    url: "/file/info/updateFile",
    method: "POSTJSON"
    //authPermission: "49"
  },
  transferFile: {
    //文件转移
    url: "/file/info/moveFields",
    method: "POSTJSON"
    //authPermission: "50"
  },
  findAllClassifyByFile: {
    url: "/file/appinfo/findAllClassify",
    method: "POSTJSON"
  },
  //--------------------------------广告插件-------------------------------------------------
  findByPaginationForBanner: {
    //分页查询广告位findByPagination
    url: "/advert/advertPositionService/findByPagination",
    method: "POSTJSON"
  },
  findBannerById: {
    //根据id获得banner基本信息
    url: "/advert/advertPositionService/getBase",
    method: "GET"
  },
  addBanner: {
    //添加广告位add
    url: "/advert/advertPositionService/add",
    method: "POSTJSON"
    //authPermission: "32"
  },
  updateBanner: {
    //修改广告位update
    url: "/advert/advertPositionService/update",
    method: "POSTJSON"
    //authPermission: "33"
  },
  deletePositionBanner: {
    //根据广告位ID删除一个广告位deletePosition
    url: "/advert/appAdvertService/deletePosition",
    method: "POSTJSON"
    //authPermission: "36"
  },
  findByPaginationImageForBanner: {
    //分页查询findByPagination
    url: "/advert/advertContentService/findByPagination",
    method: "POSTJSON"
  },
  getImageForBanner: {
    //分页查询findByPagination
    url: "/advert/advertContentService/get",
    method: "GET"
  },
  batchAddAdvertContentForBanner: {
    //指添加广告内容batchAddAdvertContent
    url: "/advert/appAdvertService/batchAddAdvertContent",
    method: "POSTJSON"
    //authPermission: "32"
  },
  updateAdvertContentForBanner: {
    //更新广告内容updateAdvertContent
    url: "/advert/appAdvertService/updateAdvertContent",
    method: "POSTJSON"
    //authPermission: "33"
  },
  deleteAdvertContent: {
    //删除广告内容deleteAdvertContent
    url: "/advert/appAdvertService/deleteAdvertContent",
    method: "POSTJSON"
    //authPermission: "33"
  },

  getBaseConfig: {
    //获取基础设置
    url: "/config/baseConfigService/getBaseConfig",
    method: "GET"
  },
  setBaseConfig: {
    //保存基础设置
    url: "/config/baseConfigService/saveBaseConfig",
    method: "POSTJSON"
    //authPermission: "77"
  },
  getSiteMail: {
    //获取站点邮箱
    url: "/config/siteMailService/getSiteMail",
    method: "GET"
  },
  setSiteMail: {
    //设置站点邮箱
    url: "/config/siteMailService/setSiteMail",
    method: "POSTJSON"
    //authPermission: "78"
  },
  getSeoCode: {
    //获取第三方代码
    url: "/config/baseConfigService/getSeoCode",
    method: "GET"
  },
  setSeoCode: {
    //保存第三方代码
    url: "/config/baseConfigService/setSeoCode",
    method: "POSTJSON"
    //authPermission: "79"
  },

  getTenantConfigByKey: {
    // 通过键值获取租户设置
    url: "/service/tenantConfig/getByKey",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },

  addTenantConfig: {
    // 添加租户配置
    url: "/service/tenantConfig/add",
    method: "POSTJSON",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },

  updateTenantConfig: {
    // 修改租户配置
    url: "/service/tenantConfig/update",
    method: "POSTJSON",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },

  getSaleCode: {
    //获取授权码
    url: "generatorTenantKey",
    method: "GET",
    baseUrl: processEnv.APP_URL
  },

  // getSiteMail: { //获取seo代码
  //   url: '/config/baseConfigService/getSeoCode',
  //   method: 'GET'
  // },
  // setSiteMail: { //设置seo代码
  //   url: '/config/baseConfigService/getSeoCode',
  //   method: 'POSTJSON'
  // },
  /*-------------------------------------------- SEO设置 ----------------------------------------------------*/
  getSeoDefaultBy: {
    //获取默认seo数据
    url: "/service/seoDefault/findSeoDefaultList",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  getSeoDefaultByNew: {
    //获取默认seo数据与全网关键词设置同步
    url: "/service/seoDefault/getSeoDefault",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  getSeoDataSourceBy: {
    //获取seo数据源
    url: "/service/seoDefault/findSeoDataSourceList",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  getSeoSpreadBy: {
    //获取修改后的seo数据
    url: "/service/seoSpread/getSeoSpread",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  saveSeoSpread: {
    //保存seo数据
    url: "/service/seoSpread/saveSeoSpread",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  updateSeoSpread: {
    //更新seo数据
    url: "/service/seoSpread/updateSeoSpread",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  getWebSiteRule: {
    //获取网址url规则
    url: "/config/siteRuleService/getWebSiteRule",
    method: "GET"
  },
  saveRule: {
    //保存优化规则
    url: "/config/siteRuleService/saveRule",
    method: "POSTJSON"
    //authPermission: "74"
  },
  findPages: {
    //获取其他关键词设置
    url: "/site/page/findPages",
    method: "POSTJSON",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  getSeoOtherBy: {
    //获取其他页面seo数据
    url: "/service/seoOther/getSeoOtherByPageId",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  saveSeoOther: {
    //保存其他页面seo数据
    url: "/service/seoOther/saveSeoOther",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  updateSeoOther: {
    //保存其他页面seo数据
    url: "/service/seoOther/updateSeoOther",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  deleteSeoOther: {
    //删除其他页面seo数据
    url: "/service/seoOther/deleteSeoOther",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },
  findSeoAppsByTenantId: {
    //获取插件关键词列表
    url: "findSeoAppsByTenantId",
    method: "GET",
    baseUrl: processEnv.APP_URL
  },
  getSeoFromSeoManager: {
    //从seomanager这获取seo数据
    url: "/service/seoManager/getSeoManager",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },

  /*-------------------------------------------- 内容组 ----------------------------------------------------*/
  saveContentGroup: {
    // 添加内容组
    url: "/cmscontent/appContentGroupService/insert",
    method: "POSTJSON"
    //authPermission: "12"
  },
  updateContentGroup: {
    // 编辑内容组
    url: "/cmscontent/appContentGroupService/update",
    method: "POSTJSON"
    //authPermission: "13"
  },
  deleteContentGroup: {
    // 删除内容组
    url: "/cmscontent/appContentGroupService/delete",
    method: "GET"
    //authPermission: "14"
  },
  selectContentGroup: {
    // 选择内容组
    url: "/cmscontent/appContentGroupService/select",
    method: "GET"
  },

  findContentGroups: {
    // 查找内容组
    url: "/cmscontent/appContentGroupService/findByPagination",
    method: "POSTJSON"
  },

  deleteByContentIdAndGroupId: {
    // 根据内容id移出内容组
    url: "/cmscontent/contentGroupingService/deleteByContentIdAndGroupId",
    method: "GET"
    //authPermission: "13"
  },
  delTaskByContentId: {
    // 根据内容id移出内容组
    url: "/examine/task/delTaskByContentId",
    method: "POSTJSON"
  },
  /*-------------------------------------------- 回收站 ----------------------------------------------------*/
  restoreAll: {
    //全部还原
    url: "/cmscontent/contentManualService/restoreAll",
    method: "GET"
    //authPermission: "6"
  },
  emptyTrash: {
    //清空回收站
    url: "/cmscontent/appContentService/emptyTrash",
    method: "GET"
    //authPermission: "7"
  },
  delContent: {
    //删除回收站
    url: "/cmscontent/appContentService/deletes",
    method: "POSTJSON"
    //authPermission: "7"
  },
  /*-------------------------------------------- 模板设置 ----------------------------------------------------*/
  findPageList: {
    // 获取模板
    url: "/site/page/findPageList",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward: true //true走gwforward转发
  },

  /*-------------------------------------------- 视频管理 ----------------------------------------------------*/
  getKSConfig: {
    // 获取金山云配置
    url: "/sk/storage/getKSConfig",
    method: "GET"
  },
  getSignature: {
    // 获取金山云签名
    url: "/sk/storage/getSignature",
    method: "POSTJSON"
  },

  // 获取阿里云签名
  getAliyunConfig: {
    url: "/alivideo/aliVideoService/createVideo",
    method: "POSTJSON"
  },

  saveVideo: {
    // 保存视频信息
    url: "/video/videoService/save",
    method: "POSTJSON"
    //authPermission: "53"
  },
  updateVideoBasic: {
    // 更新视频基础信息
    url: "/video/videoService/update",
    method: "POSTJSON"
    //authPermission: "53"
  },
  updateVideoMeta: {
    // 更新视频源信息
    url: "/video/app/updateVideoMeta",
    method: "POSTJSON"
    //authPermission: "53"
  },
  updateVideoTransCode: {
    // 将视频源转码
    url: "/video/app/updateVideoTransCode",
    method: "POSTJSON"
    //authPermission: "53"
  },
  findVideoByPagination: {
    // 获取视频列表
    url: "/video/videoService/findByPagination",
    method: "POSTJSON"
  },
  deleteVideo: {
    // 删除视频
    url: "/video/app/batchDelete",
    method: "POSTJSON"
    //authPermission: "56"
  },
  getVideoCount: {
    // 获取分类视频总数
    url: "/video/videoService/getCount",
    method: "GET"
  },
  batchTransfer: {
    // 移动视频
    url: "/video/videoService/batchTransfer",
    method: "POSTJSON"
    //authPermission: "55"
  },
  findAllClassifyByVideo: {
    //获取APP_ID下所有视频分类findAllClassify及数量
    url: "/video/app/findAllClassify",
    method: "POSTJSON"
  },
  findByVideoId: {
    //根据视频ID获取视频
    url: "/video/videoService/findById",
    method: "GET"
  },

  // 新增视频服务提供方列表
  addVideoSupplier: {
    url: "/video/videoSupplierService/save",
    method: "POSTJSON"
  },

  // 获取使用状态获取服务商
  getSupplierByStatus: {
    url: "/video/videoSupplierService/findListByStatus",
    method: "GET"
  },

  // 获取视频服务提供方列表
  getVideoSupplierList: {
    url: "/video/videoSupplierService/findAll",
    method: "GET"
  },

  // 更新视频服务接口
  updateVideoSupplier: {
    url: "/video/videoSupplierService/update",
    method: "POSTJSON"
  },
  // 获取视频资源
  getVideoUsage: {
    url: "/video/videoService/getVideoUsage",
    method: "GET"
  },
  // 获取视频资源
  getUsedAndTotalCapacity: {
    url: "/video/videoService/getUsedAndTotalCapacity",
    method: "GET"
  },

  /*-------------------------------------------- 日志 ----------------------------------------------------*/

  log: {
    // 日志
    url: "/log/operLogService/findByPagination",
    method: "POSTJSON"
  },

  /*-------------------------------------------- 权限设置 ----------------------------------------------------*/

  // 获取已有权限
  selectPermission: {
    url: "/selectPermissions",
    method: "GET",
    baseUrl: processEnv.PERMISSION_URL
  },

  getRoles: {
    url: "/v2/UserRole/{memberCode}/getRolesByUserInfo",
    method: "GET",
    baseUrl: processEnv.PERMISSION_URL
  },

  // 获取所有权限项
  findPermissions: {
    url: "/findPermissions",
    method: "GET",
    baseUrl: processEnv.PERMISSION_URL
  },

  // 更新权限
  updatePermission: {
    url: "/v1/UpdatePermission",
    method: "POST",
    baseUrl: processEnv.PERMISSION_URL
  },

  /*-------------------------------------------- 系统设置 ----------------------------------------------------*/
  getIpList: {
    //ip黑名单
    url: "/blackList/blackListService/findByPagination",
    method: "POSTJSON",
    baseUrl: processEnv.IP_ROOT
  },
  getIpNum: {
    url: "/blackList/blackListService/findCount",
    method: "GET",
    baseUrl: processEnv.IP_ROOT
  },
  addIp: {
    url: "/blackList/blackListService/save",
    method: "POSTJSON",
    baseUrl: processEnv.IP_ROOT
    //authPermission: "71"
  },
  updateIp: {
    url: "/blackList/blackListService/update",
    method: "POSTJSON",
    baseUrl: processEnv.IP_ROOT
    //authPermission: "72"
  },
  deleteIp: {
    url: "/blackList/blackListService/deleteByIds",
    method: "POSTJSON",
    baseUrl: processEnv.IP_ROOT
    //authPermission: "73"
  },
  getSensitiveWordList: {
    //敏感词列表
    url: "/illegalWord/illegalWordService/findByPagination",
    method: "POSTJSON",
    baseUrl: "/api"
  },
  deleteSensitiveWord: {
    url: "/illegalWord/illegalWordService/deleteByIds",
    method: "POSTJSON",
    baseUrl: "/api"
    //authPermission: "70"
  },
  addSensitiveWord: {
    url: "/illegalWord/illegalWordService/save",
    method: "POSTJSON",
    baseUrl: "/api"
    //authPermission: "68"
  },
  updateSensitiveWord: {
    url: "/illegalWord/illegalWordService/update",
    method: "POSTJSON",
    baseUrl: "/api"
    //authPermission: "69"
  },
  upLoadSensitiveWord: {
    url: "/illegalWord/illegalWordService/importData",
    method: "POSTJSON",
    baseUrl: "/api"
    //authPermission: "68"
  },
  exportTemplate: {
    //下载敏感词模板
    url: processEnv.AUTHORITY ? processEnv.GATEWAY ? processEnv.GATEWAY + "/local/export/illegalTemplate.do" : "/export/illegalTemplate.do" : "/illegalWord/illegalWordService/exportTemplate",
    method: "GET",
    //authPermission: "68",
    baseUrl: processEnv.AUTHORITY ? processEnv.API_ROOT : processEnv.SENSITIVEWORD_URL,
    authority: 1
  },
  getRemindList: {
    //业务提醒列表
    url: "/remind/event/findEventByConditionWithPage",
    method: "POSTJSON"
  },
  findRemindedAppList: {
    //获取应用列表
    url: "/remind/event/findRemindedAppList",
    method: "GET"
  },
  // 获取业务提醒详情
  getRemind: {
    url: "/remind/event/findAllTemplateByEventId",
    method: "GET"
  },

  getRemindTemplate: {
    //初始化模板内容
    url: "/remind/event/findTemplateByEventIdOrFormId",
    method: "GET"
  },
  restoreTemplateDefault: {
    //恢复默认模板
    url: "/remind/event/findTemplateByTempId",
    method: "GET"
  },
  getEventParams: {
    //获取事件替换属性
    url: "/remind/event/findParamsByEventId",
    method: "GET"
  },
  saveRemind: {
    //保存业务提醒
    url: "/remind/event/updateTemplate",
    method: "POSTJSON"
    //authPermission: "76"
  },
  emailTestTemp: {
    //模板邮件测试
    url: "/remind/event/sendTestEmail",
    method: "POSTJSON"
  },
  emailTestSet: {
    //设置邮件测试
    url: "/config/messageSenderService/sendMailMessage",
    method: "POSTJSON"
  },
  messageboardCategory: {
    url: "/messageboard/messageboardCategory/find",
    method: "GET"
  },
  // 获取所有敏感词
  findAllIllegalWord: {
    url: "/illegalWord/illegalWordService/findListAll",
    method: "GET",
    baseUrl: "/api"
  },
  getLoginUser: {
    url: processEnv.GATEWAY ? processEnv.GATEWAY + "/local/getLoginUser.do" : "/getLoginUser.do",
    method: "GET",
    baseUrl: processEnv.MANAGER_URL,
    authority: 1 //不需要拦截
  },
  cleanAllStatic: {
    // 一键清除静态化
    url: processEnv.GATEWAY ? processEnv.GATEWAY + "/local/static/cleanStaitcPageAll.do" : "/static/cleanStaitcPageAll.do",
    method: "GET",
    // authPermission: "340"
    authority: 1 //不需要拦截
  },
  /********************高呈接口***********************/
  getSiteList: {
    url: "/site-api/getSites",
    method: "GET",
    baseUrl: processEnv.MCENTER_URL,
    authority: 1 //不需要拦截
  },
  getRoleList: {
    //获取角色列表
    url: "/v1/Role/getRoleByCondition",
    method: "GET",
    baseUrl: processEnv.PERMISSION_URL
  },
  getUserList: {
    //获取用户列表
    url: "/user-api/getUserListByCustId",
    method: "GET",
    baseUrl: processEnv.MCENTER_URL,
    authority: 1 //不需要拦截
  },

  /*-------------------------------------------- 审核设置 ----------------------------------------------------*/
  findByConditionWithPage: {
    // 获取审核流列表
    url: "/examine/definition/findByConditionWithPage",
    method: "POSTJSON"
  },
  validateName: {
    // 校验审核流名称是否存在
    url: "/examine/definition/validateName",
    method: "GET"
  },
  saveDefinition: {
    // 新增审核流
    url: "/examine/definition/saveDefinition",
    method: "POSTJSON"
    //authPermission: "37"
  },
  validateStep: {
    // 校验是否可更新stepslist
    url: "/examine/definition/validateStep",
    method: "GET"
  },
  updateDefinition: {
    // 更新审核流
    url: "/examine/definition/updateDefinition",
    method: "POSTJSON"
    //authPermission: "38"
  },
  deleteDefinition: {
    // 删除审核流
    url: "/examine/definition/deleteDefinition",
    method: "POSTJSON"
    //authPermission: "39"
  },
  getDefinitionById: {
    // 根据ID获取审核流
    url: "/examine/definition/getDefinitionById",
    method: "GET"
  },
  updateColumnBase: {
    // 修改栏目审核设置
    url: "/cmscolumn/column/updateColumnBase",
    method: "POSTJSON"
    //authPermission: "101"
  },
  getDefinitionByRelationId: {
    // 保存审核流的关联
    url: "/examine/definition/getDefinitionByRelationId",
    method: "GET"
  },
  saveRelation: {
    // 保存审核流的关联
    url: "/examine/definition/saveRelation",
    method: "POSTJSON"
    //authPermission: "101"
  },
  updateRelation: {
    // 更新审核流的关联
    url: "/examine/definition/updateRelation",
    method: "POSTJSON"
    //authPermission: "38"
  },
  validateRelation: {
    // 校验是否可以修改关联
    url: "/examine/definition/validateRelation",
    method: "POSTJSON"
  },
  deleteRelation: {
    // 删除栏目与审核间的关联
    url: "/examine/definition/deleteRelation",
    method: "POSTJSON"
  },
  findTaskByConditionWithPage: { // 获取审批任务列表
    url: "/examine/task/findTaskByConditionWithPage",
    method: "POSTJSON"
  },
  findAppTaskByConditionWithPage: { // 获取审批任务列表
    url: '/examine/apptask/findTaskByConditionWithPage',
    method: 'POSTJSON'
  },
  findAppTaskLogByCondition: { // 获取审批任务列表
    url: '/examine/apptask/findTaskLogByCondition',
    method: 'POSTJSON'
  },
  saveTask: {
    // 保存审批任务
    url: "/examine/apptask/saveTask",
    method: "POSTJSON"
    //authPermission: "columnId:27"
  },
  findTaskDetail: {
    // 根据ID获取审批任务
    url: "/examine/task/findTaskDetail",
    method: "GET"
  },
  validateExamine: {
    // 判断用户是否有当前的审批权限
    url: "/examine/task/validateExamine",
    method: "GET"
  },
  updateTask: {
    // 审批任务
    url: "/examine/apptask/updateTask",
    method: "POSTJSON"
  },
  updateTaskName: {
    // 更新审核任务名
    url: "/examine/task/updateTaskName",
    method: "POSTJSON"
    //authPermission: "38"
  },
  findTaskLogByCondition: {
    // 根据审批任务ID获取审批日志
    url: "/examine/task/findTaskLogByCondition",
    method: "POSTJSON"
  },
  findTaskLogByConditionWithPage: { // 根据审批任务ID获取审批日志
    url: '/examine/apptask/findTaskLogByConditionWithPage',
    method: 'POSTJSON'
  },

  /*-------------------------------------------- 万能表单 ----------------------------------------------------*/
  getCollectionFormList: {
    //获取所有收集到的表单
    url: "/formAttrValue/formAttrValueService/getAllFormNumber",
    method: "POSTJSON",
    baseUrl: "/gcapi"
  },
  deleteMoreFormNumber: {
    //删除收集到的表单
    url: "/formAttrValue/formAttrValueService/deleteMoreFormNumber",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    //authPermission: "63"
  },
  updateFormNumber: {
    //更新收集到的表单
    url: "/formAttrValue/formAttrValueService/updateFormNumber",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    //authPermission: "62"
  },
  getAttrValue: {
    //根据ID获取收集到的表单
    url: "/formAttrValue/formAttrValueService/getAttrValue",
    method: "GET",
    baseUrl: "/gcapi"
  },
  saveFormNumberRemarks: {
    //备注表单
    url: "/formAttrValue/formAttrValueService/saveFormNumberRemarks",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    //authPermission: "62"
  },
  getAllFormNoPage: {
    //获取所有表单设置没有分页
    url: "/universalfForm/universalfFormService/getAllForm",
    method: "GET",
    baseUrl: "/gcapi"
  },
  getAllForm: {
    //获取所有表单设置
    url: "/universalfForm/universalfFormService/getAllFormByCondition",
    method: "POSTJSON",
    baseUrl: "/gcapi"
  },
  getFormSettingById: {
    //根据ID获取表单
    url: "/universalfForm/universalfFormService/getForm",
    method: "GET",
    baseUrl: "/gcapi"
  },
  getFormFiexd: {
    //获取表单固有字段
    url: "/universalfForm/universalfFormService/getFormFiexd",
    method: "GET",
    baseUrl: "/gcapi"
  },
  saveForm: {
    //保存表单设置
    url: "/universalfForm/universalfFormService/saveForm",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    //authPermission: "64"
  },
  updateFormStatus: {
    //更改表单状态
    url: "/universalfForm/universalfFormService/updateForm",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    //authPermission: "65"
  },
  deleteFormSetting: {
    //更改表单状态
    url: "/universalfForm/universalfFormService/deleteForm",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    //authPermission: "66"
  },
  getPrivacy: {
    //获取隐私政策
    url: "/universalfForm/universalfFormService/getPrivacy",
    method: "GET",
    baseUrl: "/gcapi"
  },
  updatePrivacy: {
    //更新隐私政策
    url: "/universalfForm/universalfFormService/updatePrivacy",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    //authPermission: "67"
  },
  exportFormValueAllList: {
    //导出所有表单
    url: "/exportFormData/exportFormDataService/exportFormValueAllList",
    method: "GET",
    baseUrl: "/gcapi",
    authority: 1 //不需要拦截
  },
  exportFormValueList: {
    //获取指定表单的导出路径
    url: "/exportFormData/exportFormDataService/exportFormValueList",
    method: "POSTJSON",
    baseUrl: "/gcapi"
  },
  exportByFilePath: {
    //根据导出路径下载文件
    url: "/exportFormData/exportFormDataService/export",
    method: "GET",
    baseUrl: "/gcapi",
    authority: 1 //不需要拦截
  },
  universalfForm_getRecipientMail: {
    //获取转发设置详情
    url: "/universalfForm/universalfFormService/getRecipientMail",
    method: "GET",
    baseUrl: "/gcapi",
    authority: 1
  },
  universalfForm_updateRecipientMail: {
    //编辑转发设置
    url: "/universalfForm/universalfFormService/updateRecipientMail",
    method: "POSTJSON",
    baseUrl: "/gcapi",
    authority: 1
  },

  /*-------------------------------------------- 留言 ----------------------------------------------------*/

  // 全网后台接口
  // http://10.12.52.51:1982/api/messageboard/appMessageboardMessage/findMessageAndRelpyByPagination?tenantId=1600024221

  // 获取留言列表
  getMessageList: {
    url: "/messageboard/appMessageboardMessage/findMessageAndRelpyByPagination",
    method: "POSTJSON"
  },

  // 根据留言id显示隐藏留言
  updateMessageDisplayFlag: {
    url: "/messageboard/messageboardMessage/updateDisplayFlagByIds",
    method: "POSTJSON"
    //authPermission: "61"
  },

  // 根据留言id删除留言
  deleteMessage: {
    url: "/messageboard/messageboardMessage/deleteByIds",
    method: "POSTJSON"
    //authPermission: "59"
  },

  // 根据留言id获取回复
  getMessageReplyList: {
    url: "/messageboard/messageboardMessage/findReplyListByMessageId",
    method: "POSTJSON"
  },

  // 添加回复
  saveMessageReply: {
    url: "/messageboard/messageboardReply/saveReply",
    method: "POSTJSON"
    //authPermission: "58"
  },

  // 根据回复id显示隐藏回复
  updateMessageReplyDisplayFlag: {
    url: "/messageboard/messageboardReply/updateDisplayFlag",
    method: "POSTJSON"
    //authPermission: "61"
  },

  // 根据留言id和回复id删除回复
  updateMessageReplyDeleteFlag: {
    url: "/messageboard/messageboardReply/updateDeleteFlag",
    method: "POSTJSON"
    //authPermission: "59"
  },

  // 获取留言表单列表
  getMessageFormList: {
    url: "/messageboard/messageboardCategory/findByIndexPagination",
    method: "POSTJSON"
  },

  // 获取所有留言表单列表
  getAllMessageFormList: {
    url: "/messageboard/messageboardCategory/findByPagination",
    method: "POSTJSON"
  },

  // 留言表单启用/停用
  updatetMessageFormUseFlag: {
    url: "/messageboard/messageboardCategory/updateUseFlag",
    method: "POSTJSON"
    //authPermission: "81"
  },

  // 获取表单详情
  getMessageFormDetail: {
    url: "/messageboard/messageboardCategory/get",
    method: "GET"
  },

  // 保存表单
  saveMessageForm: {
    url: "/messageboard/messageboardForm/saveForm",
    method: "POSTJSON"
    //authPermission: "80"
  },

  // 更新表单
  updateMessageForm: {
    url: "/messageboard/messageboardForm/updateForm",
    method: "POSTJSON"
    //authPermission: "81"
  },

  // 获取表单固定项
  getTemplateFormWithItem: {
    url: "/messageboard/messageboardForm/getTemplateFormWithItem",
    method: "GET"
  },

  // 获取表单项
  getMessageFormItemList: {
    url: "/messageboard/messageboardForm/getFormWithItem",
    method: "GET"
  },

  /*-------------------------------------------- 地图 ----------------------------------------------------*/
  //获取网点列表
  getMapList: {
    url: "/map/position/findByPagination",
    method: "POSTJSON"
  },
  //根据Id获取网点
  getMapById: {
    url: "/map/position/getDetail",
    method: "GET"
  },
  //添加网点
  addMap: {
    url: "/map/position/add",
    method: "POSTJSON"
    //authPermission: "40"
  },
  //编辑网点
  editMap: {
    url: "/map/position/update",
    method: "POSTJSON"
    //authPermission: "41"
  },
  //删除网点
  deleteMapById: {
    url: "/map/position/delete",
    method: "GET"
    //authPermission: "42"
  },
  //获取所有品牌
  getCardList: {
    url: "/map/card/findCardAllPosition",
    method: "GET"
  },
  //根据ID获取品牌
  getCardById: {
    url: "/map/card/getById",
    method: "GET"
  },
  //更新品牌
  editCard: {
    url: "/map/card/update",
    method: "POSTJSON"
    //authPermission: "99"
  },
  //添加品牌
  addCard: {
    url: "/map/card/add",
    method: "POSTJSON"
    //authPermission: "100"
  },
  //删除品牌
  deleteCardById: {
    url: "/map/card/deleteById",
    method: "GET"
    //authPermission: "42"
  },

  //获取所有分类
  getCategoryList: {
    url: "/map/category/findPositionCount",
    method: "GET"
  },

  //获取详细地址
  getBaiDuMap: {
    url: "/map/position/getBaiDuMap",
    method: "GET"
  },

  //根据ID获取分类
  getCategoryById: {
    url: "/map/category/getCategoryById",
    method: "GET"
  },
  //更新分类
  editCategory: {
    url: "/map/category/update",
    method: "POSTJSON"
    //authPermission: "96"
  },
  //添加分类
  addCategory: {
    url: "/map/category/add",
    method: "POSTJSON"
    //authPermission: "95"
  },
  //删除分类
  deleteCategoryById: {
    url: "/map/category/delete",
    method: "GET"
    //authPermission: "97"
  },
  //更新地图拖拽排序
  updateMapSort: {
    url: "/map/position/updateSort",
    method: "POSTJSON"
  },

  /*-------------------------------------------- 招聘 ----------------------------------------------------*/
  //查询所有职能部门
  getDepartmentList: {
    url: "/job/department/findAll",
    method: "GET",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).JOB_URL
  },
  //保存职能部门
  addDepartment: {
    url: "/job/department/saveJobDepartment",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).JOB_URL
    //authPermission: "105"
  },
  //修改职能部门
  updateDepartment: {
    url: "/job/department/updateJobDepartment",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).JOB_URL
    //authPermission: "106"
  },
  //根据批量删除id职能部门
  deleteDepartment: {
    url: "/job/department/deleteJobDepartmentByIds",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).JOB_URL
    //authPermission: "107"
  },
  //分页查询职务列表
  getJobList: {
    url: "/job/posting/findWithPage",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).JOB_URL
  },
  //根据职务id获取特定的职务
  getJobById: {
    url: "/job/posting/getJobById",
    method: "GET",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).GCJOB_URL
  },
  //保存职务
  addJob: {
    url: "/job/posting/saveJob",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).GCJOB_URL
    //authPermission: "102"
  },
  //修改职务
  updateJob: {
    url: "/job/posting/updateJob",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).GCJOB_URL
    //authPermission: "103"
  },
  //根据批量职务Id删除职务
  deleteJob: {
    url: "/job/posting/deleteJobByIds",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).GCJOB_URL
    //authPermission: "104"
  },
  //修改显示隐藏状态
  updateState: {
    url: "/job/posting/updateState",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).JOB_URL
    //authPermission: "103"
  },
  //修改职位部门
  updateJobDepartment: {
    url: "/job/posting/updateDepartment",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).JOB_URL
    //authPermission: "103"
  },
  //修改职位发布时间
  updatePublicTime: {
    url: "/job/posting/updatePublicTime",
    method: "POSTJSON",
    baseUrl: __webpack_require__.i({"NODE_ENV":"production.private","APP_URL":"/","domain":"yun300.cn","MCENTER_URL":"/mcenter/","MCENTER_ROOT":"http://mcenter.yuechengkg.com/mcenter/","MEMBER_ROOT":"//zhengda.ceultimate.com.cn/","ANSWER_MNG":"/answerMng","PERMISSION_URL":"/authority","MENU_URL":"/menu","API_ROOT":"/manager","ORIGINAL_ROOT":"/api","IP_ROOT":"/api","SENSITIVEWORD_URL":"/api","MULTIFORM_URL":"/gcapi","CNFOL_URL":"/gcapi","SUNHOPE_URL":"/gcapi","GCJOBNEW_URL":"/gcapi","GCDAILY_URL":"/gcapi","AUTHORITY":true,"DOM_AUTHORITY":true,"ISPRIVATE":true,"SASSSERVICE_ROOT":"/saasapi/service-site","GATEWAY":"/groupsite","DSSRESOURCES":"/dssresources"}).JOB_URL
    //authPermission: "103"
  },

  //获取岗位列表（新需求）
  getJobPageList: {
    url: "/job/posting/getJobPageList",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    // authPermission: "103"
  },

  //获取申请人列表（新需求）
  getJobApplyDataList: {
    url: "/job/posting/getJobApplyDataList",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    // authPermission: "103"
  },

  //导出全部申请人信息
  exportJobApplyData: {
    url: "/exportApplyData/exportApplyDataService/exportJobApplyData",
    method: "GET",
    baseUrl: "/gcapi",
    // authPermission: "103"
    authority: 1 //不需要拦截
  },

  //生成选择数据的Excel和附件的压缩包
  generateApplyDataFile: {
    url: "/exportApplyData/exportApplyDataService/generateApplyDataFile",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    // authPermission: "103"
  },

  //根据url下载文件
  exportApplyByFilePath: {
    url: "/exportApplyData/exportApplyDataService/exportByFilePath",
    method: "GET",
    baseUrl: "/gcapi",
    // authPermission: "103"
    authority: 1 //不需要拦截
  },

  //根据id删除申请（新需求）
  deleteJobApplyData: {
    url: "/job/posting/deleteJobApplyData",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    // authPermission: "103"
  },

  //获取申请人详情（新需求）
  getJobApplyDataById: {
    url: "/job/posting/getJobApplyDataById",
    method: "GET",
    baseUrl: "/gcapi"
    // authPermission: "103"
  },

  //根据职位id获取接收者邮箱
  getRecipientMail: {
    url: "/job/posting/getRecipientMail",
    method: "GET",
    baseUrl: "/gcapi"
    // authPermission: "103"
  },

  //添加或修改接收者邮箱
  updateRecipientMail: {
    url: "/job/posting/updateRecipientMail",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    // authPermission: "103"
  },

  //查询招聘表单字段
  getJobForm: {
    url: "/job/posting/getJobForm",
    method: "GET",
    baseUrl: "/gcapi"
    // authPermission: "103"
  },

  //修改表单
  updateJobForm: {
    url: "/job/posting/updateJobForm",
    method: "POSTJSON",
    baseUrl: "/gcapi"
    // authPermission: "103"
  },

  /*********获取会员中心页面***************/
  delColumnValidate: {
    url: "/cmscontent/appContentForwardService/isForward",
    method: "POSTJSON"
  },

  /*********中金净值相关接口***************/
  importNetWorthFile: {
    //导入净值文件
    url: "/netWorth/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  importETFNetWorthFile: {
    //导入ETF净值文件
    url: "/netWorthProduct/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  importStockFile: {
    //导入组合持仓文件
    url: "/combinationPosition/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  importTrackFile: {
    //导入追踪差异文件
    url: "/etf/track/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  getNetWorthList: {
    //获取净值列表
    url: "/netWorth/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getETFnetWorthList: {
    //获取ETF净值列表
    url: "/netWorthProduct/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getStockList: {
    //获取组合持仓列表
    url: "/combinationPosition/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getTrackList: {
    //获取追踪差异列表
    url: "/etf/track/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getNetWorthById: {
    //根据id获取净值
    url: "/netWorth/selectDetailsById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getETFNetWorthById: {
    //根据id获取ETF净值
    url: "/netWorthProduct/selectDetailsById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getStockById: {
    //根据id获取组合持仓
    url: "/combinationPosition/selectDetailsById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getTrackById: {
    //根据id获取追踪差异
    url: "/etf/track/selectById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateNetWorth: {
    //更新净值
    url: "/netWorth/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateETFNetWorth: {
    //更新ETF净值
    url: "/netWorthProduct/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateStock: {
    //更新组合持仓
    url: "/combinationPosition/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateTrack: {
    //更新组合持仓
    url: "/etf/track/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteNetWorthById: {
    //删除净值
    url: "/netWorth/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteETFNetWorthById: {
    //删除ETF净值
    url: "/netWorthProduct/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteStockById: {
    //删除组合持仓
    url: "/combinationPosition/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteTrackById: {
    //删除追踪差异
    url: "/etf/track/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  getBonusList: {
    //分红列表
    url: "/bonus/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getProductList: {
    //产品列表
    url: "/product/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  addBonus: {
    //添加分红
    url: "/bonus/synch",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateBonus: {
    //更新分红
    url: "/bonus/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getBonusById: {
    //根据id查询分红详情
    url: "/bonus/toEdit",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteBonus: {
    //删除分红
    url: "/bonus/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  getHolidayList: {
    //获取节假日列表
    url: "/holiday/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  addHoliday: {
    //添加节假日
    url: "/holiday/synch",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteHoliday: {
    //删除节假日
    url: "/holiday/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getHolidayById: {
    //根据id查找节假日
    url: "/holiday/selectDetailsById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateHoliday: {
    //根据id查找节假日
    url: "/holiday/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  downloadHolidayTemplate: {
    //下载节假日模版
    url: "/holiday/exprotTemplate",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  importHolidayFile: {
    //导入节假日文件
    url: "/holiday/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },

  selectProductNwsListPage: {
    //查询产品净值的综合数据(分页)
    url: "/netWorth/selectProductNwsListPage",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  /*********中金客户相关接口***************/
  getCustomerList: {
    //获取客户列表
    url: "/customer/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getAllCustomerList: {
    //获取客户列表(不带分页)
    url: "/customer/queryAll",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  addCustomer: {
    //新增客户
    url: "/customer/synch",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getCustomerById: {
    //新增客户
    url: "/customer/toEdit",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateCustomer: {
    //更新客户
    url: "/customer/update",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteCustomer: {
    //删除客户
    url: "/customer/delete",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  getCustomerGroupList: {
    //获取客户分组列表
    url: "/grouping/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getCustomerAllGroupList: {
    //获取客户分组列表(不分页)
    url: "/grouping/queryAll",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  addCustomerGroup: {
    //添加客户分组
    url: "/grouping/synch",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getCustomerGroupById: {
    //根据id获取客户分组
    url: "/grouping/toEdit",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateCustomerGroup: {
    //编辑客户分组
    url: "/grouping/update",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteCustomerGroup: {
    //删除客户分组
    url: "/grouping/delete",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  getEmailList: {
    //获取发送邮件列表
    url: "/mail/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteEmail: {
    //删除邮件
    url: "/mail/delete",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  sendEmailToCustomer: {
    //发送邮件
    url: "/mail/send",
    method: "SENDMAIL",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  getEmailDetail: {
    //获取邮件详情
    url: "/mail/findMailById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  /*********人员管理相关接口***************/
  importEmployee: {
    //导入员工信息
    url: "/peopleDigital/employee/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  addEmployee: {
    //添加员工信息
    url: "/peopleDigital/employee/add",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  deleteEmployee: {
    //删除员工信息
    url: "/peopleDigital/employee/delete",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  modifyEmployee: {
    //修改员工信息
    url: "/peopleDigital/employee/modify",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  getEmployeeList: {
    //获取员工信息列表
    url: "/peopleDigital/employee/list",
    method: "GET",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  getEmployeeById: {
    //获取员工信息列表
    url: "/peopleDigital/employee/getEmployeeById",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  setEmployeeRegionByIds: {
    //根据ID变更区域信息
    url: "/peopleDigital/employee/setRegionByIds",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  setEmployeeColumnStatus: {
    //设置员工字段显示、隐藏
    url: "/peopleDigital/employee/setColumnStatus",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  importBranch: {
    //导入分公司信息
    url: "/peopleDigital/branch/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  addBranch: {
    //添加分公司信息
    url: "/peopleDigital/branch/add",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  deleteBranch: {
    //删除分公司信息
    url: "/peopleDigital/branch/delete",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  modifyBranch: {
    //修改分公司信息
    url: "/peopleDigital/branch/modify",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  getBranchList: {
    //获取分公司信息列表
    url: "/peopleDigital/branch/list",
    method: "GET",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  getBranchById: {
    //根据ID获取分公司信息列表
    url: "/peopleDigital/branch/getBranchById",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  setBranchRegionByIds: {
    //根据ID变更分公司信息
    url: "/peopleDigital/branch/setRegionByIds",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  setBranchColumnStatus: {
    //设置分公司字段显示、隐藏
    url: "/peopleDigital/branch/setColumnStatus",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  importAgent: {
    //导入代理商信息
    url: "/peopleDigital/agent/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  addAgent: {
    //添加代理商信息
    url: "/peopleDigital/agent/add",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  deleteAgent: {
    //删除代理商信息
    url: "/peopleDigital/agent/delete",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  modifyAgent: {
    //修改代理商信息
    url: "/peopleDigital/agent/modify",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  getAgentList: {
    //获取代理商信息列表
    url: "/peopleDigital/agent/list",
    method: "GET",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  getAgentById: {
    //根据ID获取代理商信息列表
    url: "/peopleDigital/agent/getAgentById",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  setAgentRegionByIds: {
    //根据ID变更代理商信息
    url: "/peopleDigital/agent/setRegionByIds",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  setAgentColumnStatus: {
    //设置代理商字段显示、隐藏
    url: "/peopleDigital/agent/setColumnStatus",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  addRegion: {
    //添加区域信息
    url: "/peopleDigital/region/add",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  deleteRegion: {
    //删除区域信息
    url: "/peopleDigital/region/delete",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  modifyRegion: {
    //修改区域信息
    url: "/peopleDigital/region/modify",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  getRegionList: {
    //获取区域信息列表
    url: "/peopleDigital/region/list",
    method: "GET",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },
  getRegionById: {
    //根据ID获取区域信息列表
    url: "/peopleDigital/region/getRegionById",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL
    // authority: 1 //不需要拦截
  },

  /*********尚赫相关接口***************/
  webSiteOverview: {
    //网站概况
    url: "/statistics/StatisticsService/webSiteOverview",
    method: "POSTJSON",
    baseUrl: processEnv.SUNHOPE_URL
    // authority: 1 //不需要拦截
  },
  downloadOverview: {
    //下载记录
    url: "/statistics/StatisticsService/dowViews",
    method: "POSTJSON",
    baseUrl: processEnv.SUNHOPE_URL
    // authority: 1 //不需要拦截
  },
  viewStatisticsList: {
    //统计列表
    url: "/statistics/StatisticsService/viewList",
    method: "POSTJSON",
    baseUrl: processEnv.SUNHOPE_URL
    // authority: 1 //不需要拦截
  },
  exportAccessList: {
    //导出excel
    url: "/statistics/StatisticsService/exportAccessList",
    method: "GET",
    baseUrl: processEnv.SUNHOPE_URL,
    authority: 1 //不需要拦截
    //authPermission: "306"
  },

  /***********************************上海共创*************************************/
  //获取问卷列表
  getQuestionnaireList: {
    url: "/questionnaire/list",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //添加问卷
  addQuestionnaire: {
    url: "/questionnaire/synch",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //获取问卷详情
  getQuestionnaireDetail: {
    url: "/questionnaire/echoEcho",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //更新问卷
  updateQuestionnaire: {
    url: "/questionnaire/updateById",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //更新问卷状态（有效/无效）
  updateQuestionnaireStatus: {
    url: "/questionnaire/updateStatusById",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //删除问卷
  deleteQuestionnaire: {
    url: "/questionnaire/deleteByIds",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //获取问卷转发设置详情
  getQuestionnaireEmailCfg: {
    url: "/questionnaire/findEmailConfig",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //更新问卷转发设置
  updateQuestionnaireEmailCfg: {
    url: "/questionnaire/updateEmailConfigById",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },

  //获取答卷列表
  getAnswerList: {
    url: "/useriofo/list",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //获取答卷详情
  getAnswerDetail: {
    url: "/useriofo/findEditEcho",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //删除答卷
  deleteAnswer: {
    url: "/useriofo/deleteByIds",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //更新答卷状态（有效/无效）
  updateAnswerStatus: {
    url: "/useriofo/updateStatusByUuid",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //添加答卷处理日志
  addAnswerHandleLog: {
    url: "/useriofo/insertPaperProcessingByUuid",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //导出所有答卷
  exportAllAnswer: {
    url: "/useriofo/exprotTemplate",
    baseUrl: processEnv.ANSWER_MNG,
    method: "GET",
    authority: 1
  },
  //导出选中的答卷
  exportSelectedAnswer: {
    url: "/useriofo/exprotTemplateByUuid",
    baseUrl: processEnv.ANSWER_MNG,
    method: "GET",
    authority: 1
  }
};
/* Object.defineProperty(store.state.admin,'permissionInfo',{
  get:function(){
      return permissionInfo;
  },
  set:function(newValue){
    permissionInfo=newValue;

    console.log('set1 :',newValue);
    //需要触发的渲染函数可以写在这...
    store.state.admin.permissionInfo = newValue
    config.saveColumn.authPermission = newValue.column_add
    console.log('set 21:',config.saveColumn);

  }
}) */
setTimeout(function () {
  //栏目
  config.saveColumn.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_add;
  config.copyColumn.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_add;
  config.deleteColumnByColumnIds.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_delete;
  config.validColumnByColumnIds.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_delete;
  config.delColumnValidate.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_delete;
  config.updateColumn.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_update;
  config.batchUpdateDisplay.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_update;
  config.ResetColumnGroupPK.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_update;
  config.dragAndDropSort.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_sort;
  config.batchMoveColumn.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.column_transfer;
  config.saveGroup.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.colum_group_add;
  config.updateGroup.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.colum_group_update;
  config.saveColumnGroupPK.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.colum_group_update;
  config.deleteGroup.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.colum_group_delete;
  config.saveField.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_add;
  config.saveFieldByTempId.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_add;
  config.updateField.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_update;
  config.updateFieldBase.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_update;
  config.dragAndDropSortField.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_sort;
  config.saveOrUpdateValidate.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_update;
  config.deleteField.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_delete;
  config.saveFieldGroup.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_group_add;
  config.updateFieldGroup.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_group_update;
  config.deleteFieldGroup.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.field_group_delete;
  config.rebackContent.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_retrieve_reback;
  config.deleteImageInfo.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_delete;
  config.updateImage.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_update;
  config.updateImageInfo.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_update;
  config.uploadImage.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_add;
  config.setWaterMark.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_setting;
  config.cancelWatermark.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_setting;
  config.saveOrUpdateWaterMark.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_setting;
  config.updateAppCode.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_transfer;
  config.saveClassify.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_addtype;
  config.updateClassify.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_updatetype;
  config.deleteClassifyByIds.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.image_deletetype;
  config.uploadFile.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.file_add;
  config.saveFile.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.file_add;
  config.updateFile.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.file_update;
  config.modifyFileName.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.file_update;
  config.deleteFileByIds.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.file_delete;
  config.transferFile.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.file_transfer;
  config.addBanner.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.banner_add;
  //config.batchAddAdvertContentForBanner.authPermission = store.state.admin.permissionInfo.banner_add
  config.updateBanner.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.banner_update;
  config.updateAdvertContentForBanner.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.banner_update;
  config.deleteAdvertContent.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.banner_update;
  config.deletePositionBanner.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.banner_delete;
  config.setBaseConfig.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.basic_setting;
  config.setSiteMail.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.email_setting;
  config.setSeoCode.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.thirdparty_setting;
  config.saveSeoSpread.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.seo_betterrule;
  config.updateSeoSpread.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.seo_betterrule;
  config.saveSeoOther.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.seo_betterrule;
  config.updateSeoOther.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.seo_betterrule;
  config.deleteSeoOther.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.seo_betterrule;
  config.saveRule.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.seo_urlrule;
  config.saveContentGroup.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_group_add;
  config.updateContentGroup.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_group_update;

  config.deleteContentGroup.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_group_delete;
  config.deleteByContentIdAndGroupId.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_group_update;
  config.restoreAll.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_retrieve_reback;
  config.emptyTrash.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_retrieve_clear;
  config.delContent.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_retrieve_clear;

  config.saveVideo.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.video_add;
  config.updateVideoBasic.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.video_add;
  config.updateVideoMeta.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.video_add;
  config.updateVideoTransCode.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.video_add;
  config.deleteVideo.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.video_delete;
  config.batchTransfer.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.video_transfer;
  config.addIp.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.ipBlockList_add;
  config.updateIp.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.ipBlockList_update;
  config.deleteIp.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.ipBlockList_delete;
  config.deleteSensitiveWord.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.sensitiveWord_delete;
  config.addSensitiveWord.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.sensitiveWord_add;
  config.upLoadSensitiveWord.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.sensitiveWord_add;
  config.exportTemplate.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.sensitiveWord_add;
  config.updateSensitiveWord.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.sensitiveWord_update;
  config.saveRemind.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.businessReminding_set;
  config.saveDefinition.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.check_add;
  config.updateDefinition.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.check_update;
  config.updateRelation.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.check_open;
  //config.updateTaskName.authPermission = store.state.admin.permissionInfo.check_update  
  config.deleteDefinition.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.check_delete;
  config.updateColumnBase.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.check_open;
  config.saveRelation.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.check_open;

  config.deleteMoreFormNumber.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.omnipotentForm_delete;
  config.updateFormNumber.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.omnipotentForm_deal;
  config.saveFormNumberRemarks.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.omnipotentForm_deal;
  config.saveForm.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.omnipotentForm_set_add;
  config.updateFormStatus.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.omnipotentForm_set_update;
  config.deleteFormSetting.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.omnipotentForm_set_delete;
  config.updatePrivacy.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.omnipotentForm_policy_update;
  config.updateMessageDisplayFlag.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.message_update;
  config.updateMessageReplyDisplayFlag.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.message_update;
  config.deleteMessage.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.message_delete;
  config.updateMessageReplyDeleteFlag.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.message_delete;
  config.saveMessageReply.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.message_reply;
  config.updatetMessageFormUseFlag.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.message_set_update;
  config.updateMessageForm.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.message_set_update;
  config.saveMessageForm.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.message_set_add;
  config.addMap.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.map_add;
  config.editMap.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.map_update;
  config.deleteMapById.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.map_delete;
  config.editCard.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.map_updateBrand;
  config.addCard.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.map_addBrand; //
  config.deleteCardById.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.map_delBrand;
  config.editCategory.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.map_updatetype;
  config.addCategory.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.map_addtype;
  config.deleteCategoryById.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.map_deltype;
  config.addDepartment.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.department_add;
  config.updateDepartment.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.department_update;
  config.deleteDepartment.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.department_del;
  config.addJob.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.job_posted;
  config.updateJob.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.job_update;
  config.updateState.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.job_update;
  config.updateJobDepartment.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.department_update;
  config.updatePublicTime.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.department_update;
  config.deleteJob.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.job_del;
  config.exportAccessList.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.download_statistics;
  config.updateTenantConfig.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.advanced_response;
  config.addTenantConfig.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.advanced_response;
  config.cleanAllStatic.authPermission = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.page_statization;

  config.insertContent.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_add;
  config.importContentTemplate.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_add;
  config.copyInsert.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_add;
  config.saveTask.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_add;
  config.updateContent.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_update;
  config.updateShow.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_update;
  config.top.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_update;
  config.recommend.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_update;
  config.ResetContentGroupPK.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_update;
  config.hot.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_update;
  config.sort.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_sort;
  config.updateDel.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_delete;
  config.contentTransfer.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_transfer;
  config.manualForward.authPermission = 'columnId:' + __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.admin.permissionInfo.content_transfer;
}, 3000);

var constans = {
  // 常量
  RIGHT_CODE: ["101", "102", 200, "200"], // 正常
  REQUIRE_LOGIN: "999", // 用户未登录
  JURIS_CODE: "200", // 有权限
  NO_JURIS: "403" //没有权限
};
var errorCode = {};
var errorCodeByType = {};
errorCode[constans["RIGHT_CODE"]] = {};
errorCode[constans["REQUIRE_LOGIN"]] = {
  message: "用户未登录"
};
errorCode[constans["DEFAULT_CODE"]] = {
  message: "网络繁忙，请重试"
};
errorCode[constans["NO_JURIS"]] = {
  message: "没有权限，请联系管理员"
};



/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = api;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return forwardParam; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index_js__ = __webpack_require__(70);
/**
 * Created by zhangxiaoqing on 2017/5/16.
 */



function api(url, urlData, data) {
  var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'GET';
  var baseUrl = arguments[4];
  var authPermission = arguments[5];
  var authority = arguments[6];
  var isGwforward = arguments[7];

  var tenantId = __WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].state.webset.tenantId && __WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].state.webset.tenantId;
  //tenantId = 123889
  var gateway = "/groupsite"; //新的网关不走转发
  var TOKEN = __WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].state.TOKEN && __WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].state.TOKEN; //增加token解决设计器登录后台登录两次问题
  var isTenant =  false ? true : false; //本地环境新网关也传tenantId
  if (!gateway || gateway && isTenant) urlData.tenantId = tenantId;

  var keyddd = url.indexOf('?') == -1 ? '?' : '&';
  if (url.indexOf('_d=') == -1) {
    url = url + keyddd + "_d=" + new Date().getTime();
  } else {
    url = changeURLArg(url, '_d', new Date().getTime());
  }
  //替换参数的值
  function changeURLArg(url, arg, arg_val) {
    var pattern = arg + '=([^&]*)';
    var replaceText = arg + '=' + arg_val;
    if (url.match(pattern)) {
      var tmp = '/(' + arg + '=)([^&]*)/gi';
      tmp = url.replace(eval(tmp), replaceText);
      return tmp;
    } else {
      if (url.match('[\?]')) {
        return url + '&' + replaceText;
      } else {
        return url + '?' + replaceText;
      }
    }
    return url + '\n' + arg + '\n' + arg_val;
  }

  switch (method) {
    case 'FILE':
      for (var key in urlData) {
        url.indexOf('?') > 0 ? url += '&' + key + '=' + urlData[key] : url += '?' + key + '=' + urlData[key];
      }
      if (authority) {
        url = gateway ? newGateWayParam(url, baseUrl, data, authPermission, urlData, TOKEN, gateway) : forwardParam(url, baseUrl, tenantId, data, authPermission, urlData, TOKEN, isGwforward);
        baseUrl = '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__ajax__["a" /* default */].file(url, data, baseUrl);
    case 'GET':
      if (!gateway || gateway && isTenant) data.tenantId = tenantId;
      for (var _key in data) {
        url.indexOf('?') > 0 ? url += '&' + _key + '=' + data[_key] : url += '?' + _key + '=' + data[_key];
      }
      if (authority) {
        url = gateway ? newGateWayParam(url, baseUrl, data, authPermission, urlData, TOKEN, gateway) : forwardParam(url, baseUrl, tenantId, data, authPermission, urlData, TOKEN, isGwforward);
        baseUrl = '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__ajax__["a" /* default */].get(url, baseUrl);
    case 'POSTJSON':
      for (var key in urlData) {
        url.indexOf('?') > 0 ? url += '&' + key + '=' + urlData[key] : url += '?' + key + '=' + urlData[key];
      }
      if (authority) {
        url = gateway ? newGateWayParam(url, baseUrl, data, authPermission, urlData, TOKEN, gateway) : forwardParam(url, baseUrl, tenantId, data, authPermission, urlData, TOKEN, isGwforward);
        baseUrl = '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__ajax__["a" /* default */].postJson(url, data, baseUrl);

    case 'POST':
      for (var key in urlData) {
        url.indexOf('?') > 0 ? url += '&' + key + '=' + urlData[key] : url += '?' + key + '=' + urlData[key];
      }
      if (authority) {
        url = gateway ? newGateWayParam(url, baseUrl, data, authPermission, urlData, TOKEN, gateway) : forwardParam(url, baseUrl, tenantId, data, authPermission, urlData, TOKEN, isGwforward);
        baseUrl = '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__ajax__["a" /* default */].post(url, data, baseUrl);

    case 'UPLOADFILE':
      for (var key in urlData) {
        url.indexOf('?') > 0 ? url += '&' + key + '=' + urlData[key] : url += '?' + key + '=' + urlData[key];
      }
      if (authority) {
        url = gateway ? newGateWayParam(url, baseUrl, data, authPermission, urlData, TOKEN, gateway) : forwardParam(url, baseUrl, tenantId, data, authPermission, urlData, TOKEN, isGwforward);
        baseUrl = '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__ajax__["a" /* default */].uploadFile(url, data, baseUrl);

    case 'SENDMAIL':
      for (var key in urlData) {
        url.indexOf('?') > 0 ? url += '&' + key + '=' + urlData[key] : url += '?' + key + '=' + urlData[key];
      }
      if (authority) {
        url = gateway ? newGateWayParam(url, baseUrl, data, authPermission, urlData, TOKEN, gateway) : forwardParam(url, baseUrl, tenantId, data, authPermission, urlData, TOKEN, isGwforward);
        baseUrl = '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__ajax__["a" /* default */].sendMail(url, data, baseUrl);

    case 'FILESTREAM':
      for (var key in urlData) {
        url.indexOf('?') > 0 ? url += '&' + key + '=' + urlData[key] : url += '?' + key + '=' + urlData[key];
      }
      if (authority) {
        url = gateway ? newGateWayParam(url, baseUrl, data, authPermission, urlData, TOKEN, gateway) : forwardParam(url, baseUrl, tenantId, data, authPermission, urlData, TOKEN, isGwforward);
        baseUrl = '';
      }
      return __WEBPACK_IMPORTED_MODULE_0__ajax__["a" /* default */].fileStream(url, data, baseUrl);
  }
}
// export default function api (url, data, method = 'GET', baseUrl) {
//   switch (method) {
//     case 'POST':
//       data = forwardParam(url, data, 'post', baseUrl)
//       return ajax.post('', data)
//     case 'GET':
//       data = forwardParam(url, data, 'get', baseUrl)
//       return ajax.post('', data)
//       // for (let key in data) {
//       //   url.indexOf('?') > 0 ? url += '&' + key + '=' + data[key] : url += '?' + key + '=' + data[key]
//       // }
//     case 'GETREST':
//       data = forwardParam(url, data, 'get', baseUrl)
//       return ajax.post('', data)
//     case 'POSTJSON':
//       data = forwardParam(url, data, 'post', baseUrl)
//       return ajax.post('', data)
//     case 'DELETE':
//       data = forwardParam(url, data, 'delete', baseUrl)
//       return ajax.post('', data)
//     case 'PUT':
//       data = forwardParam(url, data, 'put', baseUrl)
//       return ajax.post('', data)
//   }
// }

var forwardParam = function forwardParam(url, baseUrl, tenantId, data, authPermission, urlData, TOKEN, isGwforward) {
  baseUrl = baseUrl == undefined ? "/api" : baseUrl;
  baseUrl += url;
  var idx = authPermission && authPermission.length && authPermission.indexOf(':');
  if (idx >= 0) {
    var key = authPermission.substring(0, idx);
    authPermission = data[key] ? authPermission.replace(key, data[key]) : authPermission.replace(key, urlData[key]);
    // authPermission = authPermission.slice(idx+1, authPermission.length)
  }
  if (idx == undefined) {
    authPermission = undefined;
  }
  var forward = '';
  var paramUrl = '';

  if (isGwforward) {
    //如果是saasapi 开头的 isGwforward为true的话 走gwforward 转发
    forward = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* config */].gwforward;
    paramUrl = '' + forward.url + baseUrl + '&tenantId=' + tenantId + (authPermission ? '&authPermission=' + authPermission : '') + (TOKEN ? '&TOKEN=' + TOKEN : '');
  } else {
    forward = __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* config */].originalForward;
    paramUrl = forward.url + '?url=' + encodeURIComponent(baseUrl) + '&tenantId=' + tenantId + (authPermission ? '&authPermission=' + authPermission : '') + (TOKEN ? '&TOKEN=' + TOKEN : '');
  }
  return paramUrl;
};
var newGateWayParam = function newGateWayParam(url, baseUrl, data, authPermission, urlData, TOKEN, gateway) {

  baseUrl = baseUrl == undefined ? "/api" : baseUrl;
  baseUrl += url;
  var idx = authPermission && authPermission.length && authPermission.indexOf(':');
  if (idx >= 0) {
    var key = authPermission.substring(0, idx);
    authPermission = data[key] ? authPermission.replace(key, data[key]) : authPermission.replace(key, urlData[key]);
    // authPermission = authPermission.slice(idx+1, authPermission.length)
  }
  if (idx == undefined) {
    authPermission = undefined;
  }
  var forward = { url: gateway
    // if(url.indexOf('/place/v2/search') >= 0) {
    //   forward = config.baiduMapForward;
    //   baseUrl = url
    // }
  };var perMark = baseUrl.indexOf('?') > 0 ? '&' : '?';
  var TokenMark = baseUrl.indexOf('?') > 0 || authPermission ? '&' : '?';
  var paramUrl = '' + forward.url + baseUrl + (authPermission ? perMark + 'authPermission=' + authPermission : '') + (TOKEN ? TokenMark + 'TOKEN=' + TOKEN : '');
  return paramUrl;
};


/***/ }),

/***/ 151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_index_js__ = __webpack_require__(250);



// 获取模块配置项 example: getModuleConfig('router', ['member'])
var getModuleConfig = function getModuleConfig(key, selector) {
	var selModule = getUseModule(selector);
	if (selModule.constructor === Object) {
		return selModule[key];
	}
	if (selModule.constructor === Array) {
		return selModule.map(function (sel) {
			return sel[key];
		});
	}
};

// 获取选中模块 example: getUseModule('field')
var getUseModule = function getUseModule(selector) {
	if (!selector) {
		return __WEBPACK_IMPORTED_MODULE_0__modules_index_js__["a" /* default */];
	}
	if (selector.constructor === String) {
		return __WEBPACK_IMPORTED_MODULE_0__modules_index_js__["a" /* default */].find(function (item) {
			return item.moduleName == selector;
		}) || {};
	}
	if (selector.constructor === Array) {
		return __WEBPACK_IMPORTED_MODULE_0__modules_index_js__["a" /* default */].filter(function (module) {
			return selector.indexOf(module.moduleName) >= 0;
		});
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getUseModule: getUseModule,
	getModuleConfig: getModuleConfig
});

/***/ }),

/***/ 1575:
/***/ (function(module, exports) {

module.exports = window.CKEDITOR;

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

module.exports = ELEMENT;

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return applicationId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAppId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getApps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAppName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAppByUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constans_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index_js__ = __webpack_require__(70);


var applicationId = {// 应用对应的id
};

applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['COLUMN']] = 223, //栏目id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['CONTENT']] = 224, //内容id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['IMAGE']] = 232, //图片id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['FILE']] = 233, //文件id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['VIDEO']] = 264, //视频库id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['BANNER']] = 231, //广告位id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['INFORMAN']] = 269; //信息管理id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['REVIEW']] = 252; //审批管理id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['APP']] = 270; //应用中心id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['MAP']] = 260; //地图id
applicationId[__WEBPACK_IMPORTED_MODULE_0__constans_js__["a" /* default */]['JOB']] = 2; //招聘id


var getAppId = function getAppId(id) {
  var menuObj = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.getApp.menuData;
  var appId = void 0;
  menuObj.length && menuObj.map(function (item) {
    if (item.id == id) {
      return appId = item.appId;
    }
  });
  return appId;
};

//根据父id获取子菜单
var getApps = function getApps(pId) {
  var menuObj = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.getApp.menuData;
  var targetApps = [];
  menuObj.length && menuObj.map(function (item) {
    if (item.parentId == pId) {
      targetApps.push(item);
    }
  });
  return targetApps;
};
//根据id获取appName
var getAppName = function getAppName(id) {
  var menuObj = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.getApp.menuData;
  var appName = void 0;
  menuObj.length && menuObj.map(function (item) {
    if (id == 10) {
      return appName = "意向信息";
    }
    if (item.appId == id) {
      return appName = item.name;
    }
  });
  return appName;
};
var getAppByUrl = function getAppByUrl(url) {
  var menuObj = __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].state.getApp.menuData;
  var targetApp = void 0;
  menuObj && menuObj.length && menuObj.map(function (item) {
    if (item.url == url) {
      return targetApp = item;
    }
  });
  return targetApp;
};


/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPageData */
/* unused harmony export createCode */
/* unused harmony export routeHop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUrlParam; });
/**
 * Created by zhangxiaoqing on 2017/7/25.
 */
var getPageData = function getPageData(pageSize, pageIndex, dataList) {
  var endIndex = pageSize * pageIndex;
  var startIndex = endIndex - pageSize;
  return dataList.slice(startIndex < 0 ? 0 : startIndex, endIndex);
};

/** 生成验证码 */
var createCode = function createCode() {
  var code = '';
  var codeLength = 4; // 验证码的长度
  var codeChars = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']; // 所有候选组成验证码的字符，当然也可以用中文的
  for (var i = 0; i < codeLength; i++) {
    var charNum = Math.floor(Math.random() * 52);
    code += codeChars[charNum];
  }
  return code;
};

var routeHop = function routeHop(router, pathName) {
  router.go(0);
};
var formatDate = function formatDate(date) {
  if (!date) {
    return '';
  } else {
    var dateObj = new Date(date);
    var y = dateObj.getFullYear();
    var m = dateObj.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = dateObj.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
  }
};

// 获取url参数
var getUrlParam = function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);return null;
};



/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeHtmlTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deepCopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return timeStampToDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addImageSizeSymbol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//清除富文本中html标签
var removeHtmlTag = function removeHtmlTag(html) {
	html = html.replace(/(\n)/g, "");
	html = html.replace(/(\t)/g, "");
	html = html.replace(/(\r)/g, "");
	html = html.replace(/<\/?[^>]*>/g, "");
	html = html.replace(/\s*/g, "");
	html = html.replace(/&nbsp;/g, "");
	return html;
};

var deepCopy = function deepCopy(obj) {
	return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
};

var timeStampToDate = function timeStampToDate(timestamp, fmt) {
	var date = new Date(timestamp);
	var o = {
		"M+": date.getMonth() + 1, //月份
		"d+": date.getDate(), //日
		"h+": date.getHours(), //小时
		"m+": date.getMinutes(), //分
		"s+": date.getSeconds(), //秒
		"q+": Math.floor((date.getMonth() + 3) / 3), //季度
		"S": date.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
		}
	}
	return fmt;
};

//添加图片尺寸标记
var addImageSizeSymbol = function addImageSizeSymbol(imageUrl, width, height) {
	if (!imageUrl) {
		return imageUrl;
	}
	if (imageUrl.includes('repository/image')) {
		//解析后缀名
		var suffix = imageUrl.substring(imageUrl.lastIndexOf(".") + 1, imageUrl.length);

		//拼接图片尺寸标记
		var sizeSymbol = height ? "_" + width + "x" + height + "." + suffix : "_" + width + "." + suffix;

		// //去掉多余的斜杠
		// if(useOrigin && useOrigin[useOrigin.length - 1] == '/') {
		//   useOrigin = useOrigin.substring(0, useOrigin.length - 1)
		// }

		//补充斜杠
		if (imageUrl.substring(0, 1) !== '/') {
			imageUrl = '/' + imageUrl;
		}

		//如果链接带有_100x100.jpg这种格式，则替换成新的
		if (/\_\d+\x\d+\.\w+$/ig.test(imageUrl)) {
			var targetSymbol = imageUrl.match(/\_(\d+)\x(\d+)\.(\w+)$/i);
			imageUrl = imageUrl.replace(targetSymbol[0], sizeSymbol);
		} else {
			imageUrl += sizeSymbol;
		}
	}
	return imageUrl + ("?t=" + Math.random());
	// return imageUrl;
};

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_common_js__ = __webpack_require__(215);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      headerIsShow: true
    };
  },

  watch: {
    $route: function $route(newVal, oldVal) {
      this.hideVisualHeader();
    }
  },
  computed: {},
  created: function created() {
    if (true) {
      var hostName = location.hostname;
      var arr = hostName.split('.');
      var domain = arr[arr.length - 2] + '.' + arr[arr.length - 1];
      var noDomain = ['com.cn', 'net.cn', 'org.cn', 'gov.cn', 'edu.cn'];
      if (noDomain.indexOf(domain) > -1) {
        domain = arr[arr.length - 3] + '.' + domain;
      }
      document.domain = domain;
      // document.domain = process.env.domain;
    }
    this.getTenantInfo();
    this.hideVisualHeader();
    this.updateGroupId();
  },

  methods: {
    hideVisualHeader: function hideVisualHeader() {
      this.headerIsShow = !!this.$route.path.indexOf('/visual') && !!this.$route.path.indexOf('/adminManage');
      this.isPageNotFound = this.$route.path.includes('pageNotFound');
    },


    // 存集团id
    updateGroupId: function updateGroupId() {
      this.$store.commit('updateGroupId', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_js_common_js__["a" /* getUrlParam */])('groupId') || window.localStorage.getItem('groupId'));
    },

    //获取用户信息
    getTenantInfo: function getTenantInfo() {
      this.$store.dispatch('getTenantInfo');
    }
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'empty'
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_axios__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
// import Vue from 'vue'
// import axios from 'axios'


Vue.use(__WEBPACK_IMPORTED_MODULE_0_vue_axios___default.a, axios);
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
/* import Qs from 'qs' */
/* harmony default export */ __webpack_exports__["a"] = ({
  post: function post(url, data, baseUrl) {
    var config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "post", // default
      // 基础url前缀
      baseURL: baseUrl || "/manager",
      transformRequest: [function (data) {
        // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
        data = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(data);
        return data;
      }],
      /* transformResponse: [function (data) {
        // 这里提前处理返回的数据
        return data
      }], */
      // 请求头信息
      /* headers: {'X-Requested-With': 'XMLHttpRequest'}, */
      // parameter参数
      /* params: {
        timestamp: Date.parse(new Date()) / 1000
      }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.post(url, data, config);
  },
  get: function get(url, baseUrl) {
    var config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "get", // default
      // 基础url前缀
      baseURL: baseUrl || "/manager",
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify({})
       return data
       }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      /* headers: {'X-Requested-With': 'XMLHttpRequest'}, */
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.get(url, config);
  },
  postJson: function postJson(url, data, baseUrl) {
    var config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "post", // default
      // 基础url前缀
      baseURL: baseUrl || "/manager",
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify(data)
       return data
       }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      headers: { "Content-Type": "application/json; charset=UTF-8" },
      // headers: {'Content-Type': 'application/json'},
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.post(url, data, config);
  },
  file: function file(url, data, baseUrl) {
    var config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "post", // default
      // 基础url前缀
      baseURL: baseUrl || "/manager",
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify(data)
       return data
       }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      headers: { "Content-Type": "image/png" },
      // headers: {'Content-Type': 'application/json'},
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.post(url, data, config);
  },
  uploadFile: function uploadFile(url, data, baseUrl) {
    var param = new FormData(); //创建form对象

    param.append("file", data.file); //通过append向form对象添加数据
    data.appId && param.append("appId", data.appId);
    data.columnId && param.append("columnIds", data.columnId);
    data.theirNwProductName && param.append("theirNwProductName", data.theirNwProductName);
    data.etfId && param.append("etfId", data.etfId);

    var config = {
      method: "post",
      url: url,
      baseURL: baseUrl || "/manager",
      // data: qs.stringify(data),
      timeout: 50000,
      responseType: "json",
      headers: { "Content-Type": "multipart/form-data" }
    };
    return axios.post(url, param, config);
  },
  sendMail: function sendMail(url, data, baseUrl) {
    var param = new FormData(); //创建form对象
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (key == "file") {
          data[key].forEach(function (item) {
            param.append("file[]", item, item.unicodeName);
          });
        } else {
          param.append(key, data[key]);
        }
      }
    }

    var config = {
      method: "post",
      url: url,
      baseURL: baseUrl || "/manager",
      // data: qs.stringify(data),
      responseType: "json",
      headers: { "Content-Type": "multipart/form-data" }
    };
    return axios.post(url, param, config);
  },
  fileStream: function fileStream(url, data, baseUrl) {
    var config = {
      url: url,
      method: "post", // default
      baseURL: baseUrl || "/manager",
      headers: { "Content-Type": "application/octet-stream" }
    };
    return axios.post(url, data, config);
  },
  delete: function _delete(url, baseUrl) {
    var config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "delete", // default
      // 基础url前缀
      baseURL: baseUrl || "/manager",
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify({})
       return data
       }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      /* headers: {'X-Requested-With': 'XMLHttpRequest'}, */
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.delete(url, config);
  },
  put: function put(url, data, baseUrl) {
    var config = {
      // 请求的接口，在请求的时候，如axios.get(url,config);这里的url会覆盖掉config中的url
      url: url,
      // 请求方法同上
      method: "put", // default
      // 基础url前缀
      baseURL: baseUrl || "/manager",
      /* transformRequest: [function (data) {
       // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
       data = Qs.stringify({})
       return data
      }], */
      /* transformResponse: [function (data) {
       // 这里提前处理返回的数据
       return data
       }], */
      // 请求头信息
      /* headers: {'X-Requested-With': 'XMLHttpRequest'}, */
      // parameter参数
      /* params: {
       timestamp: Date.parse(new Date()) / 1000
       }, */
      // post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
      // 设置超时时间
      timeout: 50000,
      // 返回数据类型
      responseType: "json" // default
    };
    return axios.put(url, data, config);
  }
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(231);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'banner',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var bannerManageNew = function bannerManageNew() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 570));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  path: "/bannerManage",
  name: "bannerManage",
  component: bannerManageNew,
  meta: {
    root: "/appCenter"
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(233);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'column',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var empty = function empty() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 131));
};
var columnList = function columnList() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 558));
};
var addColumn = function addColumn() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 554));
};
var selectTmp = function selectTmp() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 571));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  // 栏目管理
  path: 'column',
  name: 'columnBox',
  component: empty,
  children: [{
    path: '/columnList',
    name: 'columnList',
    component: columnList,
    meta: '/inforMan'
  }, {
    path: "/addColumn",
    name: "addColumn",
    component: addColumn,
    meta: {
      parentRoot: "/columnList", // 导航高亮
      root: "/inforMan"
    }
  }, {
    path: "/selectTmp", //选择模板
    name: "selectTmp",
    component: selectTmp,
    meta: {
      parentRoot: "/columnList", // 导航高亮
      root: "/inforMan"
    }
  }]
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(235);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'content',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var addContent = function addContent() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 555));
};
var contentList = function contentList() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 559));
};
var contentMan = function contentMan() {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 572));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  //内容管理
  path: 'content',
  name: 'contentBox',
  component: contentMan,
  meta: {
    root: '/inforMan'
  },
  children: [{
    path: '/contentList',
    name: 'contentList',
    component: contentList,
    meta: {
      title: '内容列表',
      root: '/inforMan'
    }
  }, {
    // 添加内容
    path: '/addContent',
    name: 'addContent',
    component: addContent,
    meta: {
      parentRoot: '/contentList', // 导航高亮
      root: '/inforMan'
    }
  }]
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(237);


/* harmony default export */ __webpack_exports__["a"] = ({
  moduleName: 'contentRecycleBin',
  router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var contentRecycleBin = function contentRecycleBin() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 573));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // 内容回收站
  path: "/contentRecycleBin",
  name: "contentRecycleBin",
  component: contentRecycleBin,
  meta: {
    root: "/inforMan"
  }
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(239);


/* harmony default export */ __webpack_exports__["a"] = ({
  moduleName: 'contentReview',
  router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var contentReview = function contentReview() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 574));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  //内容审核
  path: "/contentReview",
  name: "contentReview",
  component: contentReview,
  meta: {
    root: "/inforMan"
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(241);


/* harmony default export */ __webpack_exports__["a"] = ({
  moduleName: 'contentSearch',
  router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var contentSearchList = function contentSearchList() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 575));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // 内容搜索
  path: "/contentSearchList",
  name: "contentSearchList",
  component: contentSearchList,
  meta: {
    root: "/inforMan"
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(243);


/* harmony default export */ __webpack_exports__["a"] = ({
  moduleName: 'field',
  router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var fieldList = function fieldList() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 576));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // 字段设置
  path: "/fieldList",
  name: "fieldList",
  component: fieldList,
  meta: {
    root: "/inforMan"
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(245);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'file',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var fileManage = function fileManage() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 577));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // 文件管理
  path: "/fileManage",
  name: "fileManage",
  component: fileManage,
  meta: {
    root: "/appCenter"
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(247);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'group',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var groupSetting = function groupSetting() {
  return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, 582));
};
var columnGroup = function columnGroup() {
  return __webpack_require__.e/* import() */(120).then(__webpack_require__.bind(null, 578));
};
var columnListInGroup = function columnListInGroup() {
  return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, 579));
};
var contentGroup = function contentGroup() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 580));
};
var contentListInGroup = function contentListInGroup() {
  return __webpack_require__.e/* import() */(118).then(__webpack_require__.bind(null, 581));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // 组别设置
  path: "/groupSetting",
  name: "groupSetting",
  component: groupSetting,
  redirect: {
    name: "columnGroup"
  },
  children: [{
    path: "columnGroup",
    name: "columnGroup",
    component: columnGroup,
    meta: {
      root: "/inforMan"
    }
  }, {
    path: "columnListInGroup",
    name: "columnListInGroup",
    component: columnListInGroup,
    meta: {
      root: "/inforMan"
    }
  }, {
    path: "contentGroup",
    name: "contentGroup",
    component: contentGroup,
    meta: {
      root: "/inforMan"
    }
  }, {
    path: "contentListInGroup",
    name: "contentListInGroup",
    component: contentListInGroup,
    meta: {
      root: "/inforMan"
    }
  }]
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(249);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'image',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var imageManage = function imageManage() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 583));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // 图片管理
  path: "/imageManage",
  name: "imageManage",
  component: imageManage,
  meta: {
    root: "/appCenter"
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__column__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__content__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__market__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contentReview__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contentRecycleBin__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contentSearch__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__template__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__group__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__field__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__image__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__video__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__file__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__banner__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sensitiveWord__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ipBlockList__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__visual__ = __webpack_require__(261);





















/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__column__["a" /* default */], // 栏目
__WEBPACK_IMPORTED_MODULE_1__content__["a" /* default */], //内容
__WEBPACK_IMPORTED_MODULE_2__market__["a" /* default */], //营销管理

__WEBPACK_IMPORTED_MODULE_3__contentReview__["a" /* default */], // 内容审核
__WEBPACK_IMPORTED_MODULE_4__contentRecycleBin__["a" /* default */], // 内容回收站
__WEBPACK_IMPORTED_MODULE_5__contentSearch__["a" /* default */], // 内容搜索
__WEBPACK_IMPORTED_MODULE_6__template__["a" /* default */], // 模板设置
__WEBPACK_IMPORTED_MODULE_7__group__["a" /* default */], // 组别设置
__WEBPACK_IMPORTED_MODULE_8__field__["a" /* default */], // 字段管理

__WEBPACK_IMPORTED_MODULE_9__image__["a" /* default */], // 图片库
__WEBPACK_IMPORTED_MODULE_10__video__["a" /* default */], // 视频库
__WEBPACK_IMPORTED_MODULE_11__file__["a" /* default */], // 文件库
__WEBPACK_IMPORTED_MODULE_12__banner__["a" /* default */], // banner图

__WEBPACK_IMPORTED_MODULE_13__sensitiveWord__["a" /* default */], // 敏感词
__WEBPACK_IMPORTED_MODULE_14__ipBlockList__["a" /* default */], // ip黑名单

__WEBPACK_IMPORTED_MODULE_15__visual__["a" /* default */]]);

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(252);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'ipBlockList',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ipBlockList = function ipBlockList() {
  return __webpack_require__.e/* import() */(116).then(__webpack_require__.bind(null, 584));
}; //ip黑名单

/* harmony default export */ __webpack_exports__["a"] = ({
  //ip黑名单
  path: "/ipBlockList",
  name: "ipBlockList",
  component: ipBlockList,
  meta: {
    title: "ip黑名单",
    root: "/appCenter"
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(254);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'market',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var marketList = function marketList() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 592));
};
var marketEdit = function marketEdit() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 589));
};
var empty = function empty() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 131));
};
var marketHome = function marketHome() {
  return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 590));
};

var issueList = function issueList() {
  return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 586));
};
var issueEdit = function issueEdit() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 585));
};
var marketLibraryList = function marketLibraryList() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 591));
};
var weChatEmpower = function weChatEmpower() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 593));
};
var marketCategory = function marketCategory() {
  return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 587));
};
var marketCategoryEdit = function marketCategoryEdit() {
  return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, 588));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  path: 'market',
  name: 'marketBox',
  component: empty,
  children: [{
    path: '/marketList', //营销内容列表
    name: 'marketList',
    component: marketList,
    meta: {
      title: '营销内容列表',
      root: '/appCenter'
    }
  }, {
    path: '/marketEdit',
    name: 'marketEdit',
    component: marketEdit,
    meta: {
      parentRoot: '/marketList', // 导航高亮
      root: '/appCenter'
    }
  }, {
    path: '/marketHome', //营销管理首页
    name: 'marketHome',
    component: marketHome,
    meta: {
      title: '营销内容首页',
      root: '/appCenter'
    }
  }, {
    // 签名列表
    path: '/issueList',
    name: 'issueList',
    component: issueList,
    meta: {
      parentRoot: '/issueList',
      root: '/appCenter'
    }
  }, {
    // 编辑签名
    path: '/issueList/issueEdit',
    name: 'issueEdit',
    component: issueEdit,
    meta: {
      parentRoot: '/issueList',
      root: '/appCenter'
    }
  }, {
    // 员工营销库列表
    path: '/marketLibraryList',
    name: 'marketLibraryList',
    component: marketLibraryList,
    meta: {
      parentRoot: '/marketLibraryList',
      root: '/appCenter'
    }
  },
  // {
  //   // 微信授权
  //   path: '/weChatEmpower',
  //   name: 'weChatEmpower',
  //   component: weChatEmpower,
  //   meta: {
  //     parentRoot: '/weChatEmpower',
  //     root: '/appCenter'
  //   }
  // },
  {
    // 营销分类
    path: '/marketCategory',
    name: 'marketCategory',
    component: marketCategory,
    meta: {
      parentRoot: '/marketCategory',
      root: '/appCenter'
    }
  }, {
    // 添加、编辑营销分类
    path: '/marketCategoryEdit',
    name: 'marketCategoryEdit',
    component: marketCategoryEdit,
    meta: {
      parentRoot: '/marketCategory',
      root: '/appCenter'
    }
  }]
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(256);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'sensitiveWord',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sensitiveWord = function sensitiveWord() {
  return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 594));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  //敏感词
  path: "/sensitiveWord",
  name: "sensitiveWord",
  component: sensitiveWord,
  meta: {
    title: "敏感词管理",
    root: "/appCenter"
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(258);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'template',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var templateMan = function templateMan() {
  return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 598));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  path: "/templateMan",
  name: "templateMan",
  component: templateMan,
  meta: {
    root: "/inforMan"
  }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(260);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'video',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var videoManage = function videoManage() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 599));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  // 视频管理管理
  path: "/videoManage",
  name: "videoManage",
  component: videoManage,
  meta: {
    root: "/appCenter"
  }
});

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(262);


/* harmony default export */ __webpack_exports__["a"] = ({
	moduleName: 'visual',
	router: __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */]
});

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var visualBox = function visualBox() {
  return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 607));
};
var visualColumnList = function visualColumnList() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 609));
};
var visualColumnDetail = function visualColumnDetail() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 608));
};
var visualContentList = function visualContentList() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 611));
};
var visualContentDetail = function visualContentDetail() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 610));
};
var visualAddContent = function visualAddContent() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 602));
};
var visualAddColumn = function visualAddColumn() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 601));
};
var visualImageList = function visualImageList() {
  return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 612));
};
var visualAddBanner = function visualAddBanner() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 600));
};
var visualBannerList = function visualBannerList() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 606));
};
var visualBannerDetail = function visualBannerDetail() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 605));
};
var visualMapDetail = function visualMapDetail() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 614));
};
var visualMapList = function visualMapList() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 615));
};
var visualAddMap = function visualAddMap() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 603));
};
var visualMapCategoryList = function visualMapCategoryList() {
  return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 613));
};
var visualWebsiteInfo = function visualWebsiteInfo() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 619));
};
var visualAddMessage = function visualAddMessage() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 604));
};
var visualMessageFormList = function visualMessageFormList() {
  return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 617));
};
var visualMessageDetail = function visualMessageDetail() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 616));
};
var visualMessageList = function visualMessageList() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 618));
};

/* harmony default export */ __webpack_exports__["a"] = ({

  path: "/visual",
  name: "visual",
  component: visualBox,
  children: [{
    path: "contentList",
    name: "visualContentList",
    component: visualContentList
  }, {
    path: "addContent",
    name: "visualAddContent",
    component: visualAddContent
  }, {
    path: "contentDetail",
    name: "visualContentDetail",
    component: visualContentDetail
  }, {
    path: "columnList",
    name: "visualColumnList",
    component: visualColumnList
  }, {
    path: "addColumn",
    name: "visualAddColumn",
    component: visualAddColumn
  }, {
    path: "columnDetail",
    name: "visualColumnDetail",
    component: visualColumnDetail
  }, {
    path: "imageList",
    name: "visualImageList",
    component: visualImageList
  }, {
    path: "bannerList",
    name: "visualBannerList",
    component: visualBannerList
  }, {
    path: "addBanner",
    name: "visualAddBanner",
    component: visualAddBanner
  }, {
    path: "bannerDetail",
    name: "visualBannerDetail",
    component: visualBannerDetail
  }, {
    path: "mapList",
    name: "visualMapList",
    component: visualMapList
  }, {
    path: "addMap",
    name: "visualAddMap",
    component: visualAddMap
  }, {
    path: "mapDetail",
    name: "visualMapDetail",
    component: visualMapDetail
  }, {
    path: "mapCategoryList",
    name: "visualMapCategoryList",
    component: visualMapCategoryList
  }, {
    path: "websiteInfo",
    name: "visualWebsiteInfo",
    component: visualWebsiteInfo
  }, {
    path: "messageFormList",
    name: "visualMessageFormList",
    component: visualMessageFormList
  }, {
    path: "addMessage",
    name: "visualAddMessage",
    component: visualAddMessage
  }, {
    path: "messageDetail",
    name: "visualMessageDetail",
    component: visualMessageDetail
  }, {
    path: "messageList",
    name: "visualMessageList",
    component: visualMessageList
  }]
});

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  dialogMove: {
    bind: function bind(el, binding, vnode, oldVnode) {
      var dialogHeaderEl = el.querySelector(".el-dialog__header");
      var dragDom = el.querySelector(".el-dialog");

      dialogHeaderEl.style.cursor = "move";
      // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
      var sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
      dialogHeaderEl.onmousedown = function (e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        var disX = e.clientX - dialogHeaderEl.offsetLeft;
        var disY = e.clientY - dialogHeaderEl.offsetTop;
        // 获取到的值带px 正则匹配替换
        var styL = void 0,
            styT = void 0;

        // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
        if (sty.left.includes("%")) {
          styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, "") / 100);
          styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, "") / 100);
        } else {
          styL = +sty.left.replace(/\px/g, "");
          styT = +sty.top.replace(/\px/g, "");
        }

        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          var l = e.clientX - disX;

          var t = e.clientY - disY;

          // 移动当前元素
          dragDom.style.left = l + styL + "px";

          dragDom.style.top = t + styT + "px";

          //将此时的位置传出去
          //binding.value({x:e.pageX,y:e.pageY})
        };

        document.onmouseup = function (e) {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
    },

    inserted: function inserted(el, binding, vnode) {
      //2-被插入
    },
    update: function update(el, binding, vnode) {
      //3-更新

    },
    componentUpdated: function componentUpdated(el, binding, vnode) {
      //4-更新完成
      var dragDom = el.querySelector(".el-dialog");
      dragDom.style.left = "";
      dragDom.style.top = "";
    },
    unbind: function unbind(el, binding, vnode) {
      //5-解绑
    }
  }
});

/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_thumbnail_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_img_thumbnail_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_img_thumbnail_png__);


/* harmony default export */ __webpack_exports__["a"] = ({
    bind: function bind(el, binding, vnode) {
        el.onerror = function (e) {
            this.src = __WEBPACK_IMPORTED_MODULE_0__assets_img_thumbnail_png___default.a;
            this.onerror = null;
        };
    }, update: function update(el, binding, vnode) {
        el.onerror = function (e) {
            this.src = __WEBPACK_IMPORTED_MODULE_0__assets_img_thumbnail_png___default.a;
            this.onerror = null;
        };
    }
});

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v_scroll__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__imgerr_js__ = __webpack_require__(264);
// import Vue from 'vue'

Vue.directive('scroll', __WEBPACK_IMPORTED_MODULE_0__v_scroll__["a" /* default */]);


Vue.directive('imgerr', __WEBPACK_IMPORTED_MODULE_1__imgerr_js__["a" /* default */]);

/***/ }),

/***/ 266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // 当被绑定的元素插入到 DOM 中时……
  inserte: function inserte(el, _ref) {
    var value = _ref.value;

    el.scrollTop = value + 'px';
  },
  update: function update(el, _ref2) {
    var value = _ref2.value;

    el.scrollTop = value + 'px';
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_entry_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_empty_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_empty_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__core_components_empty_vue__);



var header = function header() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 149));
}; // 首页
var aside = function aside() {
  return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 148));
}; // 新高呈 - 左侧菜单
var sideMenu = function sideMenu() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 150));
}; // 左侧
//const seoSetting = () => import("@/views/settingMan/seoSetting.vue");
var seoSetting = function seoSetting() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 597));
};
var adminMan = function adminMan() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 620));
};
var operaLog = function operaLog() {
  return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 630));
};

var reviewManage = function reviewManage() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 665));
};
var businessReminding = function businessReminding() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 626));
}; //业务提醒
//const appHome = () => import("@/views/appHome/appHome.vue"); //应用首页
var appHome = function appHome() {
  return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, 569));
}; //应用首页
var multiFunctionForm = function multiFunctionForm() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 637));
}; //万能表单
var universalFormJT = function universalFormJT() {
  return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 638));
}; //万能表单

var editPolicy = function editPolicy() {
  return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 636));
}; //编辑隐私政策
var addFormSetting = function addFormSetting() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 635));
}; //添加表单设置
// 留言
var messageBox = function messageBox() {
  return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 634));
};
var messageList = function messageList() {
  return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 563));
};
var messageFormList = function messageFormList() {
  return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 562));
};
var addMessageForm = function addMessageForm() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 557));
};
//服务网点
var mapLayout = function mapLayout() {
  return __webpack_require__.e/* import() */(126).then(__webpack_require__.bind(null, 632));
};
var mapList = function mapList() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 561));
};
var mapForm = function mapForm() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 556));
};
var categoryMan = function categoryMan() {
  return __webpack_require__.e/* import() */(124).then(__webpack_require__.bind(null, 560));
};
var brandMan = function brandMan() {
  return __webpack_require__.e/* import() */(125).then(__webpack_require__.bind(null, 631));
};
//招聘
var recruitLayout = function recruitLayout() {
  return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 675));
};
var recruitList = function recruitList() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 676));
};
var recruitForm = function recruitForm() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 674));
};
var recruitDepartmentMan = function recruitDepartmentMan() {
  return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 673));
};
var applicantList = function applicantList() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 671));
};
var formSetting = function formSetting() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 672));
};
//管理员
var adminManage = function adminManage() {
  return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 621));
};
//跨站转发
var forwardManage = function forwardManage() {
  return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 628));
};
//文件库(新）
// const fileManageNew = () => import("@/views/plugin/fileManageNew/fileManage.vue");
//文件库(调用全网文件库）
var fileSetting = function fileSetting() {
  return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 678));
};
//会员管理
var memberManage = function memberManage() {
  return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 633));
};
//人员管理定制
var personnelManage = function personnelManage() {
  return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 642));
};
//数据统计
var statisticAnalysis = function statisticAnalysis() {
  return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 669));
};
var accessStatistics = function accessStatistics() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 666));
};
var downloadStatistic = function downloadStatistic() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 668));
};
var statisticDetail = function statisticDetail() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 670));
};
var downloadDetail = function downloadDetail() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 667));
};
//净值管理
var netWorthLayout = function netWorthLayout() {
  return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 654));
};
var netWorthManage = function netWorthManage() {
  return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 655));
};
var netWorthDetail = function netWorthDetail() {
  return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 653));
};
var bonusManage = function bonusManage() {
  return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 651));
};
var holidaySetting = function holidaySetting() {
  return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 652));
};
var ETFnetWorthManage = function ETFnetWorthManage() {
  return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 649));
};
var ETFnetWorthDetail = function ETFnetWorthDetail() {
  return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 648));
};
var ETFstockDetail = function ETFstockDetail() {
  return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 650));
};
var trackingDifference = function trackingDifference() {
  return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 656));
};

//客户管理
var customerLayout = function customerLayout() {
  return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 643));
};
var customerManage = function customerManage() {
  return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 644));
};
var groupManage = function groupManage() {
  return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 646));
};
var emailNotification = function emailNotification() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 645));
};
var sendEmail = function sendEmail() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 647));
};

//人员管理
var personnelLayout = function personnelLayout() {
  return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 663));
};
var employeeManage = function employeeManage() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 662));
};
var addEmployee = function addEmployee() {
  return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 659));
};
var branchManage = function branchManage() {
  return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 661));
};
var addBranch = function addBranch() {
  return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 658));
};
var agentManage = function agentManage() {
  return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 660));
};
var addAgent = function addAgent() {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 657));
};
var regionalManage = function regionalManage() {
  return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 664));
};

//答题管理
var AnswerMain = function AnswerMain() {
  return __webpack_require__.e/* import() */(127).then(__webpack_require__.bind(null, 625));
};
var AnswerList = function AnswerList() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 622));
};
var AnswerPaperList = function AnswerPaperList() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 624));
};
var AnswerPaperForm = function AnswerPaperForm() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 623));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/appCenter",
  name: "/appCenter",
  redirect: {
    name: "appHome"
  }
}, {
  //应用首页
  path: "/appHome",
  name: "appHome",
  components: {
    header: header,
    aside: aside,
    default: appHome
  }
}, {
  path: "/layout",
  name: "layout",
  components: {
    header: header,
    aside: aside,
    default: __WEBPACK_IMPORTED_MODULE_1__core_components_empty_vue___default.a,
    left: sideMenu
  },
  children: __WEBPACK_IMPORTED_MODULE_0__core_entry_js__["a" /* default */].getModuleConfig('router', ['column', 'content', 'contentReview', 'contentRecycleBin', 'contentSearch', 'template', 'field', 'group', 'ipBlockList', 'sensitiveWord', 'image', 'video', 'banner', 'file'])

}, {
  // seo设置
  path: "/seoSetting",
  name: "seoSetting",
  components: {
    header: header,
    aside: aside,
    left: sideMenu,
    default: seoSetting
  },
  meta: {
    root: "/appCenter"
  }
}, {
  path: "/adminManage",
  name: "adminManage",
  components: {
    default: adminMan
  },
  meta: {
    root: "/appCenter",
    unGetPermission: true // 不需要获取用户权限
  }
}, {
  path: "/operaLog",
  name: "operaLog",
  components: {
    header: header,
    aside: aside,
    default: operaLog,
    left: sideMenu
  },
  meta: {
    root: "/appCenter"
  }
}, {
  //审核管理
  path: "/reviewManage",
  name: "reviewManage",
  components: {
    header: header,
    aside: aside,
    default: reviewManage,
    left: sideMenu
  },
  meta: {
    root: "/appCenter"
  }
}, {
  //业务提醒
  path: "/businessReminding",
  name: "businessReminding",
  components: {
    header: header,
    aside: aside,
    default: businessReminding,
    left: sideMenu
  },
  meta: {
    title: "业务提醒",
    root: "/appCenter"
  }
}, {
  //万能表单
  path: "/omnipotentForm",
  name: "multiFunctionForm",
  components: {
    header: header,
    aside: aside,
    default: multiFunctionForm,
    left: sideMenu
  },
  meta: {
    root: "/appCenter"
  }
},

// 新万能表单
{
  path: "/universalFormJT",
  name: "universalFormJT",
  components: {
    header: header,
    aside: aside,
    default: universalFormJT,
    left: sideMenu
  },
  meta: {
    root: "/appCenter"
  }
}, {
  //编辑隐私政策
  path: "/omnipotentForm/editPolicy",
  name: "editPolicy",
  components: {
    header: header,
    aside: aside,
    default: editPolicy,
    left: sideMenu
  },
  meta: {
    root: "/appCenter"
  }
}, {
  //添加表单设置
  path: "/omnipotentForm/addFormSetting",
  name: "addFormSetting",
  components: {
    header: header,
    aside: aside,
    default: addFormSetting,
    left: sideMenu
  },
  meta: {
    root: "/appCenter"
  }
}, {
  // 人员管理
  path: "/personnelManage",
  name: "personnelManage",
  components: {
    header: header,
    aside: aside,
    default: personnelManage,
    left: sideMenu
  },
  meta: {
    root: "/appCenter"
  }
}, {
  // 留言
  path: "/message",
  name: "message",
  redirect: {
    name: "messageList"
  },
  components: {
    header: header,
    aside: aside,
    default: messageBox,
    left: sideMenu
  },
  children: [{
    path: "list",
    name: "messageList",
    component: messageList,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "formList",
    name: "messageFormList",
    component: messageFormList,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "addForm",
    name: "addMessageForm",
    component: addMessageForm,
    meta: {
      root: "/appCenter"
    }
  }]
}, {
  // 服务网点
  path: "/map",
  name: "map",
  components: {
    header: header,
    aside: aside,
    left: sideMenu,
    default: mapLayout
  },
  redirect: {
    name: "mapList"
  },
  children: [{
    path: "mapList",
    name: "mapList",
    component: mapList,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "mapForm",
    name: "mapForm",
    component: mapForm,
    meta: {
      hideMenu: true,
      root: "/appCenter"
    }
  }, {
    path: "categoryMan",
    name: "categoryMan",
    component: categoryMan,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "brandMan",
    name: "brandMan",
    component: brandMan,
    meta: {
      root: "/appCenter"
    }
  }]
}, {
  //招聘
  path: "/recruit",
  name: "recruit",
  components: {
    header: header,
    aside: aside,
    left: sideMenu,
    default: recruitLayout
  },
  redirect: {
    name: "recruitList"
  },
  children: [{
    path: "recruitList",
    name: "recruitList",
    component: recruitList
  }, {
    path: "recruitForm",
    name: "recruitForm",
    component: recruitForm,
    meta: {
      hideMenu: true
    }
  }, {
    path: "recruitDepartmentMan",
    name: "recruitDepartmentMan",
    component: recruitDepartmentMan
  }, {
    path: "applicantList",
    name: "applicantList",
    component: applicantList
  }, {
    path: "formSetting",
    name: "formSetting",
    component: formSetting,
    meta: {
      hideMenu: true
    }
  }]
}, {
  path: "/mcenter/adminManage/AdministratorManage",
  name: "mAdminManage",
  components: {
    header: header,
    aside: aside,
    default: adminManage,
    left: sideMenu
  },
  meta: {
    root: "/appCenter"
  }
}, {
  path: "/mcenter/forwardManage/forwardLog",
  name: "forwardManage",
  components: {
    header: header,
    aside: aside,
    default: forwardManage,
    left: sideMenu
  },
  meta: {
    root: "/appCenter"
  }
},
// {
//   path: "/fileManageNew",
//   name: "fileManageNew",
//   components: {
//     header: header,
//     default: fileManageNew,
//     left: sideMenu
//   }
// },
{
  path: "/fileSetting",
  name: "fileSetting",
  components: {
    header: header,
    default: fileSetting,
    left: sideMenu
  }
}, {
  // 会员管理
  path: "/memberManage",
  name: "memberManage",
  components: {
    header: header,
    aside: aside,
    default: memberManage,
    left: sideMenu
  }
}, {
  // 数据统计
  path: "/statisticAnalysis",
  name: "statisticAnalysis",
  components: {
    header: header,
    aside: aside,
    default: statisticAnalysis,
    left: sideMenu
  },
  redirect: {
    name: "accessStatistics"
  },
  children: [{
    path: "accessStatistics",
    name: "accessStatistics",
    component: accessStatistics,
    meta: {
      root: "/appCenter"
      // keepAlive: true
    }
  }, {
    path: "downloadStatistic",
    name: "downloadStatistic",
    component: downloadStatistic,
    meta: {
      root: "/appCenter"
      // keepAlive: true
    }
  }, {
    path: "statisticDetail",
    name: "statisticDetail",
    component: statisticDetail,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "downloadDetail",
    name: "downloadDetail",
    component: downloadDetail,
    meta: {
      root: "/appCenter"
    }
  }]
}, {
  // 净值管理
  path: "/netWorth",
  name: "netWorthLayout",
  components: {
    header: header,
    aside: aside,
    default: netWorthLayout,
    left: sideMenu
  },
  redirect: {
    name: "netWorthManage"
  },
  children: [{
    path: "netWorthManage",
    name: "netWorthManage",
    component: netWorthManage,
    meta: {
      keepAlive: true,
      root: "/appCenter"
    }
  }, {
    path: "netWorthDetail",
    name: "netWorthDetail",
    component: netWorthDetail,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "ETFnetWorthDetail",
    name: "ETFnetWorthDetail",
    component: ETFnetWorthDetail,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "ETFstockDetail",
    name: "ETFstockDetail",
    component: ETFstockDetail,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "trackingDifference",
    name: "trackingDifference",
    component: trackingDifference,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "bonusManage",
    name: "bonusManage",
    component: bonusManage,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "holidaySetting",
    name: "holidaySetting",
    component: holidaySetting,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "ETFnetWorthManage",
    name: "ETFnetWorthManage",
    component: ETFnetWorthManage,
    meta: {
      keepAlive: true,
      root: "/appCenter"
    }
  }]
}, {
  // 客户管理
  path: "/customer",
  name: "customerLayout",
  components: {
    header: header,
    aside: aside,
    default: customerLayout,
    left: sideMenu
  },
  redirect: {
    name: "customerManage"
  },
  children: [{
    path: "customerManage",
    name: "customerManage",
    component: customerManage,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "groupManage",
    name: "groupManage",
    component: groupManage,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "emailNotification",
    name: "emailNotification",
    component: emailNotification,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "sendEmail",
    name: "sendEmail",
    component: sendEmail,
    meta: {
      hideMenu: true,
      root: "/appCenter"
    }
  }]
}, {
  // 人员管理
  path: "/personnel",
  name: "personnelLayout",
  components: {
    header: header,
    aside: aside,
    default: personnelLayout,
    left: sideMenu
  },
  redirect: {
    name: "employeeManage"
  },
  children: [{
    path: "employeeManage",
    name: "employeeManage",
    component: employeeManage,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "addEmployee",
    name: "addEmployee",
    component: addEmployee,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "branchManage",
    name: "branchManage",
    component: branchManage,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "addBranch",
    name: "addBranch",
    component: addBranch,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "agentManage",
    name: "agentManage",
    component: agentManage,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "addAgent",
    name: "addAgent",
    component: addAgent,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "regionalManage",
    name: "regionalManage",
    component: regionalManage,
    meta: {
      hideMenu: true,
      root: "/appCenter"
    }
  }]
}, {
  // 答题管理
  path: "/answerMng",
  name: "answerMng",
  components: {
    header: header,
    aside: aside,
    left: sideMenu,
    default: AnswerMain
  },
  redirect: {
    name: "answerList"
  },
  children: [{
    path: "answerList",
    name: "answerList",
    component: AnswerList,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "answerPaperList",
    name: "answerPaperList",
    component: AnswerPaperList,
    meta: {
      root: "/appCenter"
    }
  }, {
    path: "answerPaperForm",
    name: "answerPaperForm",
    component: AnswerPaperForm,
    meta: {
      root: "/appCenter",
      hideMenu: true
    }
  }]
}]);

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_config_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_userService_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inforMan_js__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__appCenter_js__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_entry_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_application_js__ = __webpack_require__(204);








var header = function header() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 149));
}; // 首页
var aside = function aside() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 148));
}; // 新高呈 - 左侧菜单
var systemHeader = function systemHeader() {
  return __webpack_require__.e/* import() */(123).then(__webpack_require__.bind(null, 567));
}; // 系统首页
var sideMenu = function sideMenu() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 150));
};
var index = function index() {
  return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 629));
}; // 首页
var websiteSetting = function websiteSetting() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 564));
};
var fileSetting = function fileSetting() {
  return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 595));
};
var domainSetting = function domainSetting() {
  return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 677));
};
var sslSetting = function sslSetting() {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 680));
};
var imgSetting = function imgSetting() {
  return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 596));
};
var memberSetting = function memberSetting() {
  return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 679));
};
var pageNotFound = function pageNotFound() {
  return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 641));
}; //404
var iframe = function iframe() {
  return __webpack_require__.e/* import() */(122).then(__webpack_require__.bind(null, 568));
};
var onLineSetting = function onLineSetting() {
  return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 640));
};

var enquiryForm = function enquiryForm() {
  return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 627));
}; //在线询价
Vue.use(VueRouter);

var router = new VueRouter({
  base: "manage",
  mode: "history",
  suppressTransitionError: "production.private".includes('production'), // 生产环境下不抛出异常
  routes: [{
    path: "/manage/",
    redirect: {
      name: "navigation"
    }
  }, {
    path: "/",
    redirect: {
      name: "navigation"
    }
  }, {
    // 首页
    path: "/index/",
    name: "index",
    components: {
      header: systemHeader,
      aside: aside,
      default: index
    },
    meta: {}
  }, {
    // 站点设置
    path: "/websiteSetting",
    name: "websiteSetting",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: websiteSetting
    },
    meta: {}
  }, {
    // 域名设置
    path: "/domainSetting",
    name: "domainSetting",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: domainSetting
    },
    meta: {}
  }, {
    // 文件库设置
    path: "/fileSetting",
    name: "fileSetting",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: fileSetting
    },
    meta: {}
  }, {
    // ssl设置
    path: "/sslSetting",
    name: "sslSetting",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: sslSetting
    },
    meta: {}
  }, {
    // 在线客服
    path: "/onLineSetting",
    name: "onLineSetting",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: onLineSetting
    },
    meta: {}
  }, {
    // 在线询价
    path: "/enquiryForm",
    name: "enquiryForm",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: enquiryForm
    },
    meta: {}
  }, {
    // 图片库设置应用全网
    path: "/imgSetting",
    name: "imgSetting",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: imgSetting
    },
    meta: {}
  }, {
    path: "/memberSetting",
    name: "memberSetting",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: memberSetting
    },
    meta: {}
  }, {
    // iframe
    path: "/iframe",
    name: "iframe",
    components: {
      header: header,
      aside: aside,
      left: sideMenu,
      default: iframe
    },
    meta: {}
  }, {
    //404
    path: "/pageNotFound",
    name: "pageNotFound",
    components: {
      header: header,
      default: pageNotFound,
      left: sideMenu
    }
  }, {
    path: "*",
    redirect: {
      name: "pageNotFound"
    }
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__inforMan_js__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__appCenter_js__["a" /* default */]), [__WEBPACK_IMPORTED_MODULE_7__core_entry_js__["a" /* default */].getModuleConfig('router', 'visual')])
});



// 权限拦截
router.beforeEach(function (to, from, next) {
  var pathArr = to.path.split('/');
  var activeMenuItem = to.meta.parentRoot || "/" + pathArr[1];
  var menuData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__assets_js_application_js__["a" /* getAppByUrl */])(activeMenuItem);
  router.app.$options.store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["b" /* SETSELECTMENU */], menuData);

  var tenantId = to.query.tenantId;
  var isMobile = to.query.isMobile;
  var TOKEN = to.query.TOKEN ? to.query.TOKEN : router.app.$options.store.state.TOKEN;
  var unGetPermission = to.meta.unGetPermission; // 不权限获取拦截
  tenantId && router.app.$options.store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["f" /* UPDATETENANTID */], tenantId);
  tenantId && router.app.$options.store.commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types_js__["UPDATEMOBILE"], isMobile);
  router.app.$options.store.state.TOKEN = TOKEN;
  router.app.$options.store.dispatch("getLoginUser", { TOKEN: TOKEN, unGetPermission: unGetPermission, next: next });
});

router.afterEach(function (to, from) {
  Vue.nextTick(function () {
    try {
      sensors.quick("autoTrackSinglePage");
    } catch (e) {}
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var header = function header() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 149));
}; // 首页
var aside = function aside() {
  return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 148));
}; // 集团门户 - 会员中心内嵌页面 左侧菜单
var sideMenu = function sideMenu() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 150));
};

var navigation = function navigation() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 639));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "/inforMan",
  name: "inforMan",
  redirect: {
    name: "columnList"
  }
}, {
  // 信息管理
  path: "/messageList",
  name: "navigation",
  components: {
    header: header,
    aside: aside,
    left: sideMenu,
    default: navigation
  },
  meta: {
    root: "/"
  }
}]);

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

/**
 * Created by zhangxiaoqing on 2017/7/19.
 */

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

/**
 * Created by zhangxiaoqing on 2017/7/19.
 */

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_js_constans__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_userService_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);







var state = {
  allPermissions: [],
  permissionInfo: {},
  selectedPermissions: [],
  isPermissionOpen: true // dom控制权限开关
};

var getters = {
  getPermissionInfo: function getPermissionInfo(state) {
    return state.permissionInfo;
  },
  permissionInfo: function permissionInfo(state, getters, rootState) {
    return function (menuId) {
      // let userInfo = rootState.login.userInfo
      // if(!state.isPermissionOpen || userInfo.isSuper == constans['SUPERADMIN']){
      //     return false;
      // }
      var menuPermission = state.selectedPermissions.find(function (item) {
        return item.menuId == menuId;
      });
      var aAction = menuPermission ? menuPermission.split(',') : [];
      return state.allPermissions.reduce(function (total, item) {
        item.parentId == menuId && (total[item.operKey] = aAction.indexOf(item.id) >= 0);
        return total;
      }, {});
    };
  },
  currentMenuId: function currentMenuId(state, getters, rootState) {
    var selectMenu = rootState.getApp.selectMenu;
    return selectMenu && selectMenu.logicalId;
  },
  currentPermissions: function currentPermissions(state, getters) {
    return state.allPermissions.filter(function (item) {
      return item.parentId == getters.currentMenuId;
    });
  },

  isDisabled: function isDisabled(state, getters, rootState) {
    return function (permissionId) {
      if (!permissionId) {
        return;
      }
      var userInfo = rootState.login.userInfo;
      if (!state.isPermissionOpen || userInfo.isSuper == __WEBPACK_IMPORTED_MODULE_2__assets_js_constans__["a" /* default */]['SUPERADMIN']) {
        return false;
      }
      return !state.selectedPermissions.find(function (ite) {
        var aAction = ite.action.split(',');
        return aAction.indexOf(permissionId) >= 0;
      });
    };
  },
  isColumnDisabled: function isColumnDisabled(state, getters, rootState) {
    return function (permissionId, columnId) {
      var userInfo = rootState.login.userInfo;
      if (!state.isPermissionOpen || userInfo.isSuper == __WEBPACK_IMPORTED_MODULE_2__assets_js_constans__["a" /* default */]['SUPERADMIN']) {
        return false;
      }
      return !state.selectedPermissions.find(function (ite) {
        // if(item.action.indexOf(':') >= 0){
        //     let aAction = item.action.split(':')[1].split(',');
        //     return item.columnId == columnId && aAction.indexOf(permissionId) >= 0
        // }
        if (ite.columnId && ite.columnId != 'null') {
          var aAction = ite.action.split(',');
          return ite.columnId == columnId && aAction.indexOf(permissionId) >= 0;
        }
      });
    };
  }
};

var actions = {
  findPermissions: function findPermissions(context) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__api_userService_js__["a" /* default */].getResponse('findPermissions', {}).then(function (response) {
      context.commit('changeAllPermissions', response);
      var data = {};
      response.forEach(function (element) {
        if (element.serviceType == 1) {
          data[element.operKey] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(element.id);
        }
      });
      context.commit('changePermissionInfo', data);
    }).catch(function (error) {
      // Message({
      //   message: error,
      //   type: 'error'
      // });
      _this.$message.error('获取权限接口错误');
    });
  },
  getRoleIds: function getRoleIds(context, user) {
    var groupId = context.rootState.login.groupId;
    var data = {};
    if (groupId && groupId != 'null' && groupId != 'undefined') {
      data.groupId = groupId;
    }
    __WEBPACK_IMPORTED_MODULE_3__api_userService_js__["a" /* default */].getResponse('getRoles', data, false, {
      '{memberCode}': user.memberCode
    }).then(function (res) {
      if (res.length) {
        context.dispatch('selectPermission', res.map(function (item) {
          return item.id;
        }));
      }
    }).catch(function (error) {});
  },
  selectPermission: function selectPermission(context, roleIds) {
    var roleId = roleIds instanceof Array ? roleIds.join(',') : [];
    __WEBPACK_IMPORTED_MODULE_3__api_userService_js__["a" /* default */].getResponse('selectPermission', { roleIds: roleId }).then(function (response) {
      context.commit('changeSelectedPermissions', response);
      context.dispatch('findPermissions');
    }).catch(function (error) {
      // Message({
      //   message: error,
      //   type: 'error'
      // });
      //this.$message.error(error);
    });
  }
};

var mutations = {
  changePermissionInfo: function changePermissionInfo(state, result) {
    state.permissionInfo = result;
  },
  changeAllPermissions: function changeAllPermissions(state, result) {
    state.allPermissions = result;
  },
  changeSelectedPermissions: function changeSelectedPermissions(state, result) {
    state.selectedPermissions = result.rolePermissions[0].rolePermissions;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(58);





var _mutations;

/**
 * Created by zhangxiaoqing on 2018/04/17.
 */
// import * as types from '../mutation-types'

// import config from '@/assets/js/config.js'
// initial state
// shape: [{ id, quantity }]
var state = {
  menuData: window.sessionStorage.getItem('menuData') ? JSON.parse(window.sessionStorage.getItem('menuData')) : null,
  selectMenu: window.sessionStorage.getItem('selectMenu') ? JSON.parse(window.sessionStorage.getItem('selectMenu')) : null,
  parentNavId: window.sessionStorage.getItem('parentNavId') ? window.sessionStorage.getItem('parentNavId') : ''

  // getters
};var getters = {};

// actions
var actions = {
  getMenuDataByPath: function getMenuDataByPath(state, path) {
    var menuData = {};
    state.state.menuData && state.state.menuData.map(function (item) {
      var targetPath = item.url;
      if (targetPath == path) {
        return menuData = item;
      }
    });
    return menuData;
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* UPDATEMENUDATA */], function (state, menuData) {
  state.menuData = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(menuData));
  menuData.length ? window.sessionStorage.setItem('menuData', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(menuData)) : window.sessionStorage.removeItem('menuData');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* SETSELECTMENU */], function (state, menuData) {
  // let menuData =  state.menuData.find(item => item.url && path.indexOf(item.url) == 0 ); // 当前路由是否是菜单
  // if(menuData && menuData.id != (state.selectMenu && state.selectMenu.id)){ // 路由是菜单 且 是和当前菜单不一样的菜单
  state.selectMenu = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, menuData);
  menuData && window.sessionStorage.setItem('selectMenu', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(menuData));
  // }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* PARENTNAVID */], function (state, parentNavId) {
  state.parentNavId = parentNavId;
  parentNavId && window.sessionStorage.setItem('parentNavId', parentNavId);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_userService_js__ = __webpack_require__(65);


var _mutations;

/**
 * Created by zhangxiaoqing on 2017/7/19.
 */


// import config from '@/assets/js/config.js'
// initial state
// shape: [{ id, quantity }]
var state = {
  // domain:'', // 保存后台请求的地址，修改时方便（比方说从测试服改成正式服域名）
  userInfo: {}

  // getters
};var getters = {
  userInfo: function userInfo(state) {
    return state.userInfo;
  }

  // actions
};var actions = {
  getLoginUser: function getLoginUser(context, obj) {
    var TOKEN = obj.TOKEN;
    var unGetPermission = obj.unGetPermission;
    var next = obj.next;
    var param = TOKEN ? { TOKEN: TOKEN } : {};
    __WEBPACK_IMPORTED_MODULE_2__api_userService_js__["a" /* default */].getResponse('getLoginUser', param).then(function (response) {
      // 需要用户信息则校验登录
      //当第一次调登录时给sensors添加登录信息，切换路由不重复添加 
      if (!context.getters.userInfo.memberCode) {
        sensors.login(response.user.memberCode);
      }
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* UPDATEUSERINFO */], response.user);
      var tenantId = response.tenantId;
      tenantId && context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* UPDATETENANTID */], tenantId);
      next();
      !unGetPermission && context.dispatch('getRoleIds', response.user);
    }).catch(function () {
      context.commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* UPDATEUSERINFO */], {});
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* UPDATEUSERINFO */], function (state, userInfo) {
  state.userInfo = userInfo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'updateGroupId', function updateGroupId(state, val) {
  state.groupId = val;
  val ? window.localStorage.setItem('groupId', val) : window.localStorage.removeItem('groupId');
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_userService_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);



var _mutations;

/**
 * Created by zhangxiaoqing on 2018/04/17.
 */



// import config from '@/assets/js/config.js'
// initial state
// shape: [{ id, quantity }]
var state = {
  websetList: window.sessionStorage.getItem("websetList") && JSON.parse(window.sessionStorage.getItem("websetList")),
  webset: window.sessionStorage.getItem("webset") && JSON.parse(window.sessionStorage.getItem("webset")) || {
    tenantId: window.localStorage.getItem('tenantId')
  },
  tenantId: window.localStorage.getItem("tenantId"),
  isOpenMobileEditor: false,
  tenantInfo: {}
};

// getters
var getters = {
  // 开启pc端
  isOpenPc: function isOpenPc() {
    var tenantInfo = state.tenantInfo;
    return tenantInfo && tenantInfo.status != 8;
  },


  // 开启移动端
  isOpenMobile: function isOpenMobile() {
    var tenantInfo = state.tenantInfo;
    return tenantInfo && tenantInfo.mobileStatus != 8 && tenantInfo.status == 8;;
  }
};

// actions
var actions = {
  // 获取租户信息
  getTenantInfo: function getTenantInfo(_ref) {
    var state = _ref.state;

    __WEBPACK_IMPORTED_MODULE_3__api_userService_js__["a" /* default */].getResponse("getTenantInfoByTenantId", {
      id: state.tenantId
    }).then(function (res) {
      state.tenantInfo = res || {};
    }).catch(function (error) {
      console.error("获取租户信息" + error);
      //Message.error("获取租户信息" + error);
    });
  },


  // 获取移动端设置
  getMobileConfig: function getMobileConfig(_ref2) {
    var state = _ref2.state;

    __WEBPACK_IMPORTED_MODULE_3__api_userService_js__["a" /* default */].getResponse("getTenantConfigByKey", {
      key: "isOpenMobileText"
    }).then(function (res) {
      if (res && res.key == "isOpenMobileText") {
        state.isOpenMobileEditor = res.content == "1";
      }
    }).catch(function (error) {
      console.error("获取移动端设置" + error);
      //Message.error("获取移动端设置" + error);
    });
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SETTENANTID */], function (state, webset) {
  state.webset = webset;
  webset ? window.sessionStorage.setItem("webset", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(webset)) : window.sessionStorage.removeItem("webset");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* UPDATEWEBSITE */], function (state, websetList) {
  state.websetList = websetList;
  websetList ? window.sessionStorage.setItem("websetList", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(websetList)) : window.sessionStorage.removeItem("websetList");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* UPDATETENANTID */], function (state, tenantId) {
  state.tenantId = tenantId;
  tenantId ? window.localStorage.setItem("tenantId", tenantId) : window.localStorage.removeItem("tenantId");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* UPDATEMOBILEEDITOR */], function (state, isOpenMobileEditor) {
  state.isOpenMobileEditor = isOpenMobileEditor;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_js_config_js__ = __webpack_require__(133);



/**
 * 时间格式转换
 * @param time Date/Number
 * @param fmt string , 转换格式
 * demo ->  {{time | dateFormat('yyyy-MM-dd hh:mm:ss')}}
 */
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter("dateFormat", function (value, fmt) {
  if (!(value instanceof Date)) {
    value = new Date(value);
  }
  var o = {
    "M+": value.getMonth() + 1, //月份
    "d+": value.getDate(), //日
    "h+": value.getHours(), //小时
    "m+": value.getMinutes(), //分
    "s+": value.getSeconds(), //秒
    "q+": Math.floor((value.getMonth() + 3) / 3), //季度
    S: value.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (value.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return fmt;
});

/**
 * 格式转换
 * @param value Number
 * @param initUnit String , 单位
 * demo -> {{ 1024 |  fileSizeFormat('KB')}} -> 1MB
 */
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter("fileSizeFormat", function (value, initUnit) {
  if (!value) {
    return "0 Bytes";
  }
  var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
  var initIndex = void 0;
  if (initUnit) {
    initIndex = unitArr.indexOf(initUnit);
    initIndex = initIndex >= 0 ? initIndex : 0;
  }
  var srcsize = parseFloat(value);
  var index = Math.floor(Math.log(srcsize) / Math.log(1024));
  var size = srcsize / Math.pow(1024, index);

  var re = /^\d+$/;
  if (!re.test(size)) {
    size = size.toFixed(2);
  }

  return size + unitArr[index + initIndex];
});

/**
 * 固定文本内容
 * @param value string/number/boolean , 数值
 * @param key string , 键值
 * demo ->  {{1 | lang('useState')}} -> 开启
 */
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter("lang", function (value, key) {
  return __WEBPACK_IMPORTED_MODULE_1__assets_js_config_js__["a" /* default */][key][value] || "";
});

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(132)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  "data-v-91d07322",
  /* cssModules */
  null
)
Component.options.__file = "/var/lib/jenkins/workspace/前端/private-build-new-gc-vue/new_GC_master/src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-91d07322", Component.options)
  } else {
    hotAPI.reload("data-v-91d07322", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-340caa1c", module.exports)
  }
}

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('el-container', {
    staticStyle: {
      "height": "100%"
    }
  }, [(false) ? _c('el-header', [_c('router-view', {
    attrs: {
      "name": "header"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-container', {
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.headerIsShow) ? _c('el-aside', [_c('router-view', {
    attrs: {
      "name": "aside"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-aside', {
    class: _vm.$route.name
  }, [_c('router-view', {
    attrs: {
      "name": "left"
    }
  })], 1), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullpath
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-91d07322", module.exports)
  }
}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(201);
__webpack_require__(200);
module.exports = __webpack_require__(86);


/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA6CAIAAABu2d1/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0MjgyODRhNS04MTgwLTAxNGQtODkxNi1jOTE1YzFhYjhmNGQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QkVCRjI4QkQ4NzFFMTFFNEEyMThDNjAxRTI3MEI4REUiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QkVCRjI4QkM4NzFFMTFFNEEyMThDNjAxRTI3MEI4REUiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N2YzYTVmMTctOGQ4Zi0wZDQyLTk3YWMtNDc2M2JjNDg2ZDAwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjQyODI4NGE1LTgxODAtMDE0ZC04OTE2LWM5MTVjMWFiOGY0ZCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoZ0Y4UAAAHRSURBVHja7Jpfq4IwGMZzNKyQQroJv/8Xk8Hwpgv/kEak5+EIIYfappvTnfZeRXuaP7Zne9/NgrIsu64LgmDzLtC0sRsCEjRteyD7WJ9CQIImsnEqyKfBX2EA1bXR9bge1+NawV1PglDJIFuD3bVtm+d5URT3+/31ZRiGx+PxdDoRYmAmA/RuhBWInPPH4/G2lVKaJAnQV+FdsDLGPrEi0ATBcNSXxM2yDE6QWgWy5XH/mFU8CZreM4BbVdVM4q/HnbB6dBacLu7z+bTwE18zeNyvx93tdhZ+YgwXddaowgVindLMgBlQH84kngVXvZaFDOKFcQERx7GKEjLNIt3MznA+n6MoEmsggGwtG9nlchH4Ek0QrOjw8yq40OGw7MKgglU69svg+qzmMq7WPQNOi03T1HWNihufb7ebQHw4HPoUuN/vkYen7WgTvduvJ52TTPQbY5PcaFzor9er4EphVFBKsRmrQ4/AxXRzzsUzPi3gkyRJVOxB1FnTNJ2DFYFuGWPSi5URuOI7Jf3or63M4Krf02gSS52phIu1ZWdblT6IqLh2VhsMQ/qgf5eEjdx6f2nN4FoB6V9he+96XI/rPK5br7BdOwlj73Xob28/AgwAeMgEprCHEIQAAAAASUVORK5CYII="

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATEUSERINFO; });
/* unused harmony export SETWEBSET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATEMENUDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SETTENANTID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SETSELECTMENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATETENANTID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PARENTNAVID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATEWEBSITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATEMOBILEEDITOR; });
var UPDATEUSERINFO = 'updateUserInfo';
var SETWEBSET = 'setWebset';
var UPDATEMENUDATA = 'updateMenudata';
var SETTENANTID = 'setTenantId';
var SETSELECTMENU = 'setSelectMenu';
var UPDATETENANTID = 'updateTenantId';
var PARENTNAVID = 'parentNavId';
var UPDATEWEBSITE = 'updateWebsite';
var UPDATEMOBILEEDITOR = 'updateMobileEditor';

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__(86);








/* import store from '../store/index.js'
let permissionInfo = {}
Object.defineProperty(store.state.admin,'permissionInfo',{
  get:function(){
      return permissionInfo;
  },
  set:function(newValue){
    permissionInfo=newValue;
      console.log('set :',newValue);
      //需要触发的渲染函数可以写在这...
  }
}) */
/*
 所有用户的api
 */

var UserService = function () {
  function UserService() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, UserService);

    // this.tenantId = 1600002912
    // this.authority = process.env.AUTHORITY //是否通过权限拦截
    this.gateway = "/groupsite"; //新的网关不走转发
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(UserService, [{
    key: 'getResponse',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(type, data, authPermission, replaceObj) {
        var apiType, authority, isGwforward, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // data.tenantId=this.tenantId
                apiType = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* config */][type] || { url: '', method: 'POST' };
                authority = apiType.authority ? false : true;

                apiType.url = replaceObj ? this.urlReplace(apiType.url, replaceObj) : apiType.url;
                isGwforward = apiType.isGwforward;
                _context.prev = 4;
                _context.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_js__["a" /* default */])(apiType.url, {}, data, apiType.method, apiType.baseUrl, authPermission || apiType.authPermission, authority, isGwforward);

              case 7:
                response = _context.sent;

                if (!response) {
                  _context.next = 11;
                  break;
                }

                response = authority ? this.checkJurisdiction(response, type) : this.checkLogin(response);
                return _context.abrupt('return', this.resolve(response, type));

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](4);
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(_context.t0));

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 13]]);
      }));

      function getResponse(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return getResponse;
    }()
  }, {
    key: 'getResponseByBody',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(type, urlData, data, authPermission, replaceObj) {
        var apiType, authority, url, isGwforward, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apiType = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* config */][type];
                authority = apiType.authority ? false : true;
                url = replaceObj ? this.urlReplace(apiType.url, replaceObj) : apiType.url;
                isGwforward = apiType.isGwforward;
                _context2.prev = 4;

                console.log(authPermission || apiType.authPermission, '1');
                _context2.next = 8;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__api_js__["a" /* default */])(url, urlData, data, apiType.method, apiType.baseUrl, authPermission || apiType.authPermission, authority, isGwforward);

              case 8:
                response = _context2.sent;

                if (!response) {
                  _context2.next = 12;
                  break;
                }

                response = authority ? this.checkJurisdiction(response, type) : this.checkLogin(response);
                return _context2.abrupt('return', this.resolve(response, type));

              case 12:
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](4);
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(_context2.t0));

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 14]]);
      }));

      function getResponseByBody(_x5, _x6, _x7, _x8, _x9) {
        return _ref2.apply(this, arguments);
      }

      return getResponseByBody;
    }()
  }, {
    key: 'resolve',
    value: function resolve(response, type) {
      var oData = response.data;
      // oData = oData && oData.constructor==String ? JSON.parse(oData) : oData
      // let sErrorCode = oData && oData.status || response.status
      var sErrorCode = response.status;
      if (!this.gateway && oData && oData.constructor == String) {
        oData = JSON.parse(oData);
        sErrorCode = oData.status;
      }
      var oResponseData = !oData || oData.data == undefined ? oData : oData.data;
      var errMsg = (__WEBPACK_IMPORTED_MODULE_5__config_js__["b" /* errorCodeByType */][type] && __WEBPACK_IMPORTED_MODULE_5__config_js__["b" /* errorCodeByType */][type][sErrorCode] || __WEBPACK_IMPORTED_MODULE_5__config_js__["c" /* errorCode */][sErrorCode] || __WEBPACK_IMPORTED_MODULE_5__config_js__["c" /* errorCode */][__WEBPACK_IMPORTED_MODULE_5__config_js__["d" /* constans */]['DEFAULT_CODE']])['message'];
      var nextName = 'index'; // Vue.$route.meta.nextName
      return __WEBPACK_IMPORTED_MODULE_5__config_js__["d" /* constans */]['RIGHT_CODE'].includes(sErrorCode) ? oResponseData : sErrorCode === __WEBPACK_IMPORTED_MODULE_5__config_js__["d" /* constans */]['REQUIRE_LOGIN'] ? __WEBPACK_IMPORTED_MODULE_7__main__["default"].$router.push({ 'name': nextName }) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }
  }, {
    key: 'urlReplace',
    value: function urlReplace(url, replaceObj) {
      for (var key in replaceObj) {
        url = url.replace(key, replaceObj[key]);
      }
      return url;
    }
  }, {
    key: 'checkJurisdiction',
    value: function checkJurisdiction(response) {
      var oData = response.data;
      var status = oData.status;
      if (status == __WEBPACK_IMPORTED_MODULE_5__config_js__["d" /* constans */]['REQUIRE_LOGIN']) {
        // 没有权限则跳转
        var currentUrl = window.location.href;
        var paramHref = oData.location;
        paramHref = paramHref.substring(paramHref.indexOf('service=')).replace('service=', '');
        var idx = decodeURIComponent(paramHref).indexOf('?');
        var ins = idx >= 0 ? '&' : '?';
        var location = '' + oData.location + encodeURIComponent(ins + 'backurl=' + encodeURIComponent(encodeURIComponent(currentUrl)));
        window.location.href = location;
      } else {
        // 有权限
        return oData;
      }
    }
  }, {
    key: 'checkLogin',
    value: function checkLogin(response) {
      var oData = response.data;
      var status = oData.status;
      if (status == __WEBPACK_IMPORTED_MODULE_5__config_js__["d" /* constans */]['REQUIRE_LOGIN']) {
        // 没有权限则跳转
        var currentUrl = window.location.href;
        var paramHref = oData.location;
        paramHref = paramHref.substring(paramHref.indexOf('service=')).replace('service=', '');
        var idx = decodeURIComponent(paramHref).indexOf('?');
        var ins = idx >= 0 ? '&' : '?';
        var location = '' + oData.location + encodeURIComponent(ins + 'backurl=' + encodeURIComponent(encodeURIComponent(currentUrl)));
        window.location.href = location;
      }
      return response;
    }
  }]);

  return UserService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new UserService());

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_login__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_webset__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_getApp__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_adminMan__ = __webpack_require__(272);
/**
 * Created by zhangxiaoqing on 2017/7/19.
 */
// import Vue from 'vue'
// import Vuex from 'vuex'






// import createLogger from 'vuex/dist/logger'

// Vue.use(Vuex)

var debug = "production.private" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new Vuex.Store({
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  modules: {
    login: __WEBPACK_IMPORTED_MODULE_2__modules_login__["a" /* default */],
    webset: __WEBPACK_IMPORTED_MODULE_3__modules_webset__["a" /* default */],
    getApp: __WEBPACK_IMPORTED_MODULE_4__modules_getApp__["a" /* default */],
    admin: __WEBPACK_IMPORTED_MODULE_5__modules_adminMan__["a" /* default */]
  },
  strict: debug,
  plugins: []
}));

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_promise_polyfill__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_promise_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_video_player__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_video_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_less_main_less__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_less_main_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_less_main_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_less_swiper_css__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_less_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_less_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_svg_iconfont_css__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_svg_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_svg_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directive__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_filter__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directive_directive__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_awe_dnd__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_awe_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_awe_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_helper_js__ = __webpack_require__(219);





//import permissionInfo from "@/assets/js/permission.js";
// import '../mock/mock.js'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

__webpack_require__(504).Promise;

// import './syntaxhighlighter'


__webpack_require__(506);
__webpack_require__(507);








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_awe_dnd___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$ajax = __WEBPACK_IMPORTED_MODULE_4__api_api_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.devtools = "production.private" !== 'production';
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_iview__["Layout"], __WEBPACK_IMPORTED_MODULE_6_iview__["Icon"], __WEBPACK_IMPORTED_MODULE_6_iview__["Button"], __WEBPACK_IMPORTED_MODULE_6_iview__["Input"], __WEBPACK_IMPORTED_MODULE_6_iview__["Table"], __WEBPACK_IMPORTED_MODULE_6_iview__["Select"], __WEBPACK_IMPORTED_MODULE_6_iview__["Form"], __WEBPACK_IMPORTED_MODULE_6_iview__["Card"], __WEBPACK_IMPORTED_MODULE_6_iview__["Modal"]);
// Vue.use(ElementUI)
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_video_player___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;

if (!window.Promise) {
    window.Promise = __WEBPACK_IMPORTED_MODULE_5_promise_polyfill___default.a;
}

//注册全局directive
for (var key in __WEBPACK_IMPORTED_MODULE_14__directive_directive__["a" /* default */]) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive(key, __WEBPACK_IMPORTED_MODULE_14__directive_directive__["a" /* default */][key]);
}

 // 添加图片尺寸标记方法
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.addImageSizeSymbol = __WEBPACK_IMPORTED_MODULE_16__utils_helper_js__["a" /* addImageSizeSymbol */]; //挂载到Vue实例上面
//Vue.prototype.permissionInfo = permissionInfo; //权限


//神策埋点初始化
function initSensors(productName) {
    var server = 'zhongqi_production';
    if (location.host.includes('test') || location.host.includes('dev') || location.host.includes('pre') || location.port == '8090') {
        server = 'zhongqi_test';
    }
    (function (para) {
        var p = para.sdk_url,
            n = para.name,
            w = window,
            d = document,
            s = 'script',
            x = null,
            y = null;
        if (typeof w['sensorsDataAnalytic201505'] !== 'undefined') {
            return false;
        }
        w['sensorsDataAnalytic201505'] = n;
        w[n] = w[n] || function (a) {
            return function () {
                (w[n]._q = w[n]._q || []).push([a, arguments]);
            };
        };
        var ifs = ['track', 'quick', 'register', 'registerPage', 'registerOnce', 'trackSignup', 'trackAbtest', 'setProfile', 'setOnceProfile', 'appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify', 'login', 'logout', 'trackLink', 'clearAllRegister', 'getAppStatus'];
        for (var i = 0; i < ifs.length; i++) {
            w[n][ifs[i]] = w[n].call(null, ifs[i]);
        }
        if (!w[n]._t) {
            x = d.createElement(s), y = d.getElementsByTagName(s)[0];
            x.async = 1;
            x.src = p;
            x.setAttribute('charset', 'UTF-8');
            w[n].para = para;
            y.parentNode.insertBefore(x, y);
        }
    })({
        sdk_url: '../static/sensors/sensorsdata.min.js',
        heatmap_url: '../static/sensors/heatmap.min.js',
        name: 'sensors',
        server_url: 'https://sc.dadicinema.com/sa?project=' + server,
        heatmap: {
            clickmap: 'default',
            scroll_notice_map: 'default'
        }
    });
    sensors.registerPage({
        product_name: productName
    });
}
initSensors('PC会员中心-集团门户');

/* eslint-disable no-new */
/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
}));

/***/ })

},[551]);


// WEBPACK FOOTER //
// static/js/app.38e34ed7b9335a241353.js